<template>
  <div>
    <div v-if="loading">
      <loader></loader>
    </div>
    <div id="canvas">
      <img class="previous-page" src="../../img/left.svg" value="previous" @click="pagePrev" />
      <img class="next-page" src="../../img/right.svg" value="next" @click="pageNext" />
      <div class="flipbook-viewport">
        <div class="col-auto float-left bar">
          <router-link style="padding-right:90px" to="/home">Kiosk</router-link>
          <a to v-if="!index" @click="cambiarEstado('/index')">Index</a>
          <a to="/index" v-else @click="cambiarEstado('')">Close</a>
        </div>
        <div class="col-auto float-right">
          <a class="zoom-icon zoom-icon-in">Fullscreen</a>
        </div>
        <div class="container" @click="pause">
          <div class="flipbook" id="btnClick" @keyup.right="pause" @keyup.left="pause" @mousedown="pause"
            @click="pause">            
            <div :style="'background-image:url(https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-12%2Fcover_issue12.png?alt=media&token=a69bec0c-80d3-41d9-9386-31f8b6dccf0b)'"></div>
            <div :style="'background-image:url(' + pages12[0] + ')'"></div>
            <div :style="'background-image:url(' + pages12[1] + ')'"></div>
            <div :style="'background-image:url(' + pages12[2] + ')'"></div>
            <div :style="'background-image:url(' + pages12[3] + ')'"></div>
            <div :style="'background-image:url(' + pages12[4] + ')'"></div>
            <div :style="'background-image:url(' + pages12[5] + ')'"></div>
            <div :style="'background-image:url(' + pages12[6] + ')'"></div>
            <div :style="'background-image:url(' + pages12[7] + ')'"></div>
            <div :style="'background-image:url(' + pages12[8] + ')'"></div>
            <div :style="'background-image:url(' + pages12[9] + ')'"></div>
            <div :style="'background-image:url(' + pages12[10] + ')'"></div>
            <div :style="'background-image:url(' + pages12[11] + ')'"></div>
            <div :style="'background-image:url(' + pages12[12] + ')'"></div>
            <div :style="'background-image:url(' + pages12[13] + ')'"></div>
            <div :style="'background-image:url(' + pages12[14] + ')'"></div>
            <div :style="'background-image:url(' + pages12[15] + ')'"></div>
            <div :style="'background-image:url(' + pages12[16] + ')'"></div>
            <div :style="'background-image:url(' + pages12[17] + ')'"></div>
            <div :style="'background-image:url(' + pages12[18] + ')'"></div>
            <div :style="'background-image:url(' + pages12[19] + ')'"></div>
            <div :style="'background-image:url(' + pages12[20] + ')'"></div>
            <div :style="'background-image:url(' + pages12[21] + ')'"></div>
            <div :style="'background-image:url(' + pages12[22] + ')'"></div>
            <div :style="'background-image:url(' + pages12[23] + ')'">
              <a class="links articles2" style="bottom:13%; right:5%; width: 6%" target="_blank"
                @click="openLink('https://study.wearefamilyfoundation.org/')">wearefamilyfoundation</a>
            </div>
            <div :style="'background-image:url(' + pages12[24] + ')'"></div>
            <div :style="'background-image:url(' + pages12[25] + ')'"></div>
            <div :style="'background-image:url(' + pages12[26] + ')'"></div>
            <div :style="'background-image:url(' + pages12[27] + ')'"></div>
            <div :style="'background-image:url(' + pages12[28] + ')'"></div>
            <div :style="'background-image:url(' + pages12[29] + ')'"></div>
            <div :style="'background-image:url(' + pages12[30] + ')'"></div>
            <div :style="'background-image:url(' + pages12[31] + ')'"></div>
            <div :style="'background-image:url(' + pages12[32] + ')'">
              <a class="links articles2" style="bottom:5.2%; right:34.4%; width: 15.2%" target="_blank"
                @click="openLink('https://www.instagram.com/amanda_ethereal/')">@amanda_ethereal</a>
            </div>
            <div :style="'background-image:url(' + pages12[33] + ')'"> </div>
            <!-- Eco Edits -->
            <div :style="'background-image:url(' + pages12[34] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:13.8%; width: 11%" target="_blank"
                @click="openLink('https://www.acnestudios.com')">acnestudios.com</a>
              <a class="minilinks articles2" style="bottom:14.2%; left:46.5%; width: 7%" target="_blank"
                @click="openLink('https://www.baggu.com/')">baggu.com</a>
              <a class="minilinks articles2" style="top:13%; left:44.5%; width: 7%" target="_blank"
                @click="openLink('https://chylak.com/eu/en/')">chylak.com</a>
              <a class="minilinks articles2" style="top:40.7%; left:56.8%; width: 16%" target="_blank"
                @click="openLink('https://parley.tv/initiatives/dior')">parley.tv/initiatives/dior</a>
              <a class="minilinks articles2" style="bottom:7.2%; right:7.8%; width: 8.5%" target="_blank"
                @click="openLink('https://elvdenim.com/')">elvdenim.com
              </a>
              <a class="minilinks articles2" style="top:28.5%; left:58.5%; width: 8%" target="_blank"
                @click="openLink('https://gomi.design/')">gomi.design</a>
              <a class="minilinks articles2" style="bottom:33.2%; right:9%; width: 5%" target="_blank"
                @click="openLink('https://www.on.com/')">on.com</a>
              <a class="minilinks articles2" style="top:40.7%; right:5%; width: 15.8%" target="_blank"
                @click="openLink('https://plantfacedclothing.com/')">plantfacedclothing.com</a>
              <a class="minilinks articles2" style="bottom:24.7%; left:21%; width: 14.5%" target="_blank"
                @click="openLink('https://zeromariacornejo.com/')">zeromariacornejo.com</a>
            </div>
            <!---------------------------------------------------------- -->
            <div :style="'background-image:url(' + pages12[35] + ')'">
              <a class="minilinks articles2" style="bottom:12.4%; left:20%; width: 12%" target="_blank"
                @click="openLink('https://abelfragrance.com/')">abelfragrance.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:47.8%; width: 9%" target="_blank"
                @click="openLink('https://ereperez.com/')">ereperez.com
              </a>
              <a class="minilinks articles2" style="top:46%; right:35.8%; width: 9%" target="_blank"
                @click="openLink('https://www.filippa-k.com/')">filippa-k.com</a>
              <a class="minilinks articles2" style="top:52.9%; left:30.6%; width: 12.5%" target="_blank"
                @click="openLink('https://gabrielahearst.com/')">gabrielahearst.com</a>
              <a class="minilinks articles2" style="bottom:26.4%; left:19%; width: 16.4%" target="_blank"
                @click="openLink('https://www.isseymiyake.com')">isseymiyake.com</a>
              <a class="minilinks articles2" style="bottom:30%; right:35%; width: 12%" target="_blank"
                @click="openLink('https://www.monclondon.com/')">monclondon.com</a>
              <a class="minilinks articles2" style="top:28.6%; left:15.2%; width: 9%" target="_blank"
                @click="openLink('https://www.pashley.co.uk/')">pashley.co.uk
              </a>
              <a class="minilinks articles2" style="bottom:16%; right:13.5%; width: 9.2%" target="_blank"
                @click="openLink('https://www.sayebrand.com/')">sayebrand.com</a>
              <a class="minilinks articles2" style="bottom:26.5%; right:13%; width: 8.8%" target="_blank"
                @click="openLink('https://www.storymfg.com/')">storymfg.com</a>
            </div>
            <!-- End Eco Edits -->
            <div :style="'background-image:url(' + pages12[36] + ')'"></div>
            <div :style="'background-image:url(' + pages12[37] + ')'"></div>
            <div :style="'background-image:url(' + pages12[38] + ')'"></div>
            <div :style="'background-image:url(' + pages12[39] + ')'">
              <a class="links articles2" style="bottom:4.6%; right:40.2%; width: 9%" target="_blank"
                @click="openLink('https://www.instagram.com/bgirl_talash/?hl=en')">@bgirl_talash</a>
            </div>
            <div :style="'background-image:url(' + pages12[40] + ')'"></div>
            <div :style="'background-image:url(' + pages12[41] + ')'"></div>
            <div :style="'background-image:url(' + pages12[42] + ')'"></div>
            <div :style="'background-image:url(' + pages12[43] + ')'"></div>
            <div :style="'background-image:url(' + pages12[44] + ')'"></div>
            <div :style="'background-image:url(' + pages12[45] + ')'">
              <a class="links articles2" style="bottom:4.6%; right:42.2%; width: 7%" target="_blank"
                @click="openLink('https://www.instagram.com/israhirsi/?hl=en#')">@israhirsi</a>
            </div>
            <div :style="'background-image:url(' + pages12[46] + ')'"></div>
            <div :style="'background-image:url(' + pages12[47] + ')'"></div>
            <div :style="'background-image:url(' + pages12[48] + ')'"></div>
            <div :style="'background-image:url(' + pages12[49] + ')'"></div>
            <div :style="'background-image:url(' + pages12[50] + ')'"></div>
            <div :style="'background-image:url(' + pages12[51] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 10%" target="_blank"
                @click="openLink('https://www.instagram.com/iammarleydias')">@iammarleydias</a>
            </div>
            <div :style="'background-image:url(' + pages12[52] + ')'"></div>
            <div :style="'background-image:url(' + pages12[53] + ')'">
              <a class="links articles2" style="top:17.2%; left:51%; width: 13%" target="_blank"
                @click="openLink('https://www.instagram.com/andythefuture')">@andythefuture</a>
            </div>
            <div :style="'background-image:url(' + pages12[54] + ')'"></div>
            <div :style="'background-image:url(' + pages12[55] + ')'"></div>
            <div :style="'background-image:url(' + pages12[56] + ')'"></div>
            <div :style="'background-image:url(' + pages12[57] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.4%; width: 10%" target="_blank"
                @click="openLink('https://www.instagram.com/gitanjaliarao')">@gitanjaliarao</a>
            </div>
            <div :style="'background-image:url(' + pages12[58] + ')'"></div>
            <div :style="'background-image:url(' + pages12[59] + ')'"></div>
            <div :style="'background-image:url(' + pages12[60] + ')'"></div>
            <div :style="'background-image:url(' + pages12[61] + ')'"></div>
            <div :style="'background-image:url(' + pages12[62] + ')'"></div>
            <div :style="'background-image:url(' + pages12[63] + ')'">
              <a class="links articles2" style="bottom:4.7%; left:50.8%; width: 11%" target="_blank"
                @click="openLink('https://www.instagram.com/queenelectrazie')">@queenelectrazie</a>
            </div>
            <div :style="'background-image:url(' + pages12[64] + ')'"></div>
            <div :style="'background-image:url(' + pages12[65] + ')'"></div>
            <div :style="'background-image:url(' + pages12[66] + ')'">
              <a class="links articles2" style="bottom:5.2%; right:36%; width: 13.5%" target="_blank"
                @click="openLink('https://www.instagram.com/angie_busheska')">@angie_busheska</a>
            </div>
            <div :style="'background-image:url(' + pages12[67] + ')'"></div>
            <div :style="'background-image:url(' + pages12[68] + ')'"></div>
            <div :style="'background-image:url(' + pages12[69] + ')'"></div>
            <div :style="'background-image:url(' + pages12[70] + ')'"></div>
            <div :style="'background-image:url(' + pages12[71] + ')'"></div>
            <div :style="'background-image:url(' + pages12[72] + ')'"></div>
            <div :style="'background-image:url(' + pages12[73] + ')'"></div>
            <div :style="'background-image:url(' + pages12[74] + ')'"></div>
            <div :style="'background-image:url(' + pages12[75] + ')'">
              <a class="links articles2" style="bottom:4.5%; right:44%; width: 5.5%" target="_blank"
                @click="openLink('https://www.instagram.com/3fron')">@3fron</a>
            </div>
            <div :style="'background-image:url(' + pages12[76] + ')'"></div>
            <div :style="'background-image:url(' + pages12[77] + ')'"></div>
            <div :style="'background-image:url(' + pages12[78] + ')'"></div>
            <div :style="'background-image:url(' + pages12[79] + ')'">
              <a class="links articles2" style="top:23%; left:51%; width: 18%" target="_blank"
                @click="openLink('https://www.instagram.com/ciarajudge')">@ciarajudge</a>
            </div>
            <div :style="'background-image:url(' + pages12[80] + ')'"></div>
            <div :style="'background-image:url(' + pages12[81] + ')'"></div>
            <div :style="'background-image:url(' + pages12[82] + ')'"></div>
            <div :style="'background-image:url(' + pages12[83] + ')'"></div>
            <div :style="'background-image:url(' + pages12[84] + ')'"></div>
            <div :style="'background-image:url(' + pages12[85] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 9%" target="_blank"
                @click="openLink('https://www.instagram.com/abbipulling')">@abbipulling</a>
            </div>
            <div :style="'background-image:url(' + pages12[86] + ')'"></div>
            <div :style="'background-image:url(' + pages12[87] + ')'"></div>
            <div :style="'background-image:url(' + pages12[88] + ')'"></div>
            <div :style="'background-image:url(' + pages12[89] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 9.5%" target="_blank"
                @click="openLink('https://www.instagram.com/joelbervell')">@joelbervel</a>
            </div>
            <div :style="'background-image:url(' + pages12[90] + ')'"></div>
            <div :style="'background-image:url(' + pages12[91] + ')'">
              <a class="links articles2" style="top:36.8%; left:50.8%; width: 9.5%" target="_blank"
                @click="openLink('https://www.instagram.com/dizzodin')">@dizzodin</a>
            </div>
            <div :style="'background-image:url(' + pages12[92] + ')'"></div>
            <div :style="'background-image:url(' + pages12[93] + ')'"></div>
            <div :style="'background-image:url(' + pages12[94] + ')'"></div>
            <div :style="'background-image:url(' + pages12[95] + ')'"></div>
            <div :style="'background-image:url(' + pages12[96] + ')'"></div>
            <div :style="'background-image:url(' + pages12[97] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 9.5%" target="_blank"
                @click="openLink('https://www.instagram.com/alexisdenisew')">@alexisdenisew</a>
            </div>
            <div :style="'background-image:url(' + pages12[98] + ')'"></div>
            <div :style="'background-image:url(' + pages12[99] + ')'">
              <a class="links articles2" style="top:23%; left:50.8%; width: 21.5%" target="_blank"
                @click="openLink('https://www.instagram.com/thurmanperryfoundation/')">@thurmanperryfoundation</a>
            </div>
            <div :style="'background-image:url(' + pages12[100] + ')'"></div>
            <div :style="'background-image:url(' + pages12[101] + ')'"></div>
            <div :style="'background-image:url(' + pages12[102] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:51%; width: 8%" target="_blank"
                @click="openLink('https://www.instagram.com/vivianosue')">@vivianosue</a>
            </div>
            <div :style="'background-image:url(' + pages12[103] + ')'"></div>
            <div :style="'background-image:url(' + pages12[104] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:51%; width: 10.5%" target="_blank"
                @click="openLink('https://www.instagram.com/evrenalexander')">@evrenalexander</a>
            </div>
            <div :style="'background-image:url(' + pages12[105] + ')'"></div>
            <div :style="'background-image:url(' + pages12[106] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:51%; width: 6.5%" target="_blank"
                @click="openLink('https://www.instagram.com/e.w.usie')">@e.w.usie</a>
            </div>
            <div :style="'background-image:url(' + pages12[107] + ')'"></div>
            <div :style="'background-image:url(' + pages12[108] + ')'">
              <a class="minilinks articles2" style="bottom:5.2%; left:50.5%; width: 18%" target="_blank"
                @click="openLink('https://www.instagram.com/graceakosuawilliams/')">@graceakosuawilliams</a>
            </div>
            <div :style="'background-image:url(' + pages12[109] + ')'"></div>
            <div :style="'background-image:url(' + pages12[110] + ')'"></div>
            <div :style="'background-image:url(' + pages12[111] + ')'"></div>
            <div :style="'background-image:url(' + pages12[112] + ')'"></div>
            <div :style="'background-image:url(' + pages12[113] + ')'"></div>
            <div :style="'background-image:url(' + pages12[114] + ')'"></div>
            <div :style="'background-image:url(' + pages12[115] + ')'"></div>
            <div :style="'background-image:url(' + pages12[116] + ')'"></div>
            <div :style="'background-image:url(' + pages12[117] + ')'"></div>
            <div :style="'background-image:url(' + pages12[118] + ')'"></div>
            <div :style="'background-image:url(' + pages12[119] + ')'"></div>
            <div :style="'background-image:url(' + pages12[120] + ')'">
              <div class="video01">
                <vue-player ref="video1" id="video01"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-12%2Fmedia%2Fpg120_GoodTimes_CHIC_Le_Freak_(Official_Music_Video).mp4?alt=media&token=94d97d77-a7a6-4144-92ea-69a37b013a92"></vue-player>
              </div>
              <a class="minilinks articles2" style="bottom: 16%; left: 4%; width: 10%; "
                @click.prevent="playVideo01">Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages12[121] + ')'"></div>
            <div :style="'background-image:url(' + pages12[122] + ')'"></div>
            <div :style="'background-image:url(' + pages12[123] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 8.5%" target="_blank"
                @click="openLink('https://www.instagram.com/nilerodgers/')">@nilerodgers</a>
            </div>
            <div :style="'background-image:url(' + pages12[124] + ')'"></div>
            <div :style="'background-image:url(' + pages12[125] + ')'"></div>
            <div :style="'background-image:url(' + pages12[126] + ')'"></div>
            <div :style="'background-image:url(' + pages12[127] + ')'"></div>
            <div :style="'background-image:url(' + pages12[128] + ')'">
              <a class="links articles2" style="bottom:4%; left:5%; width: 13.5%" target="_blank"
                @click="openLink('https://www.charlottetilbury.com/')">charlottetilbury.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[129] + ')'"></div>
            <div :style="'background-image:url(' + pages12[130] + ')'">
              <a class="links articles2" style="bottom:4%; left:11%; width: 11.5%" target="_blank"
              @click="openLink('https://www.maccosmetics.com/')">maccosmetics.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[131] + ')'"></div>
            <div :style="'background-image:url(' + pages12[132] + ')'"></div>
            <div :style="'background-image:url(' + pages12[133] + ')'"></div>
            <div :style="'background-image:url(' + pages12[134] + ')'"></div>
            <div :style="'background-image:url(' + pages12[135] + ')'">
              <a class="links articles2" style="bottom:4%; right:3%; width: 6%" target="_blank"
              @click="openLink('https://www.chanel.com/')">chanel.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[136] + ')'">
              <a class="links articles2" style="bottom:4%; left:5%; width: 12.5%" target="_blank"
              @click="openLink('https://www.tomfordbeauty.com/')">tomfordbeauty.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[137] + ')'"></div>
            <div :style="'background-image:url(' + pages12[138] + ')'"></div>
            <div :style="'background-image:url(' + pages12[139] + ')'">
              <a class="links articles2" style="bottom:4%; right:3%; width: 6%" target="_blank"
              @click="openLink('https://www.chanel.com/')">chanel.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[140] + ')'"></div>
            <div :style="'background-image:url(' + pages12[141] + ')'"></div>
            <div :style="'background-image:url(' + pages12[142] + ')'">
              <a class="links articles2" style="bottom:4%; left:14%; width: 6% " target="_blank"
                @click="openLink('https://www.chanel.com/')">chanel.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[143] + ')'"></div>
            <div :style="'background-image:url(' + pages12[144] + ')'"></div>
            <div :style="'background-image:url(' + pages12[145] + ')'"></div>
            <div :style="'background-image:url(' + pages12[146] + ')'"></div>
            <div :style="'background-image:url(' + pages12[147] + ')'"></div>
            <div :style="'background-image:url(' + pages12[148] + ')'"></div>
            <div :style="'background-image:url(' + pages12[149] + ')'">
              <a class="minilinks articles2" style="top:32%; right:35.5%; width: 13.4%" target="_blank"
                @click="openLink('https://www.instagram.com/jeff_kangacha/')">@jeff_kangacha</a>
            </div>
            <div :style="'background-image:url(' + pages12[150] + ')'"></div>
            <div :style="'background-image:url(' + pages12[151] + ')'">
              <a class="minilinks articles2" style="bottom:6.8%; right:13%; width: 5% " target="_blank"
                @click="openLink('https://www.patou.com/')">Patou.com</a>
              <a class="minilinks articles2" style="bottom:5.4%; right:3%; width: 8.5% " target="_blank"
                @click="openLink('https://www.janissavitt.com/')">Janissavitt.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[152] + ')'">
              <a class="minilinks articles2" style="bottom:10.2%; left:5%; width: 12.5% " target="_blank"
                @click="openLink('https://www.dolcegabbana.com/')">dolcegabbana.com</a>
              <a class="minilinks articles2" style="bottom:7%; left:8%; width: 11% " target="_blank"
                @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 6% " target="_blank"
                @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:10%; width: 8.5% " target="_blank"
                @click="openLink('https://www.janissavitt.com/')">Janissavitt.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[153] + ')'"></div>
            <div :style="'background-image:url(' + pages12[154] + ')'">
              <a class="minilinks articles2" style="bottom:10%; left:8%; width: 10.5%" target="_blank"
                @click="openLink('https://www.ysl.com/')">ysl.com</a>
              <a class="minilinks articles2" style="bottom:8.7%; left:4%; width: 16%" target="_blank"
                @click="openLink('https://www.ysl.com/')">ysl.com</a>
              <a class="minilinks articles2" style="bottom:5.4%; left:4.5%; width: 9%" target="_blank"
                @click="openLink('https://www.janissavitt.com/')">Janissavitt.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[155] + ')'"></div>
            <div :style="'background-image:url(' + pages12[156] + ')'">
              <a class="minilinks articles2" style="bottom:10.2%; left:16.5%; width: 4%" target="_blank"
                @click="openLink('https://www.marcjacobs.com/')">marc</a>
              <a class="minilinks articles2" style="bottom:8.5%; left:3%; width: 3.4%" target="_blank"
                @click="openLink('https://www.marcjacobs.com/')">jacobs.com</a>
              <a class="minilinks articles2" style="bottom:8.5%; left:17%; width: 3.4%" target="_blank"
                @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:6.8%; left:3%; width: 12%" target="_blank"
                @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:5.4%; left:14%; width: 8%" target="_blank"
                @click="openLink('https://www.janissavitt.com/')">Janissavitt.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[157] + ')'"></div>
            <div :style="'background-image:url(' + pages12[158] + ')'"></div>
            <div :style="'background-image:url(' + pages12[159] + ')'"></div>
            <div :style="'background-image:url(' + pages12[160] + ')'"></div>
            <div :style="'background-image:url(' + pages12[161] + ')'"></div>
            <div :style="'background-image:url(' + pages12[162] + ')'"></div>
            <div :style="'background-image:url(' + pages12[163] + ')'">
              <a class="minilinks articles2" style="bottom: 27.8%; right: 2%; width: 10%; "
              @click.prevent="onPlayerReadybanner01(media[154])">Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages12[164] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:50.8%; width: 11.5% " target="_blank"
                @click="openLink('https://www.instagram.com/gracevanderwaal/')">@gracevanderwaal</a>
            </div>
            <div :style="'background-image:url(' + pages12[165] + ')'"></div>
            <div :style="'background-image:url(' + pages12[166] + ')'"></div>
            <div :style="'background-image:url(' + pages12[167] + ')'">
              <a class="minilinks articles2" style="bottom: 29.2%; right: 2%; width: 10%; "
              @click.prevent="onPlayerReadybanner02(media[155])">Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages12[168] + ')'"></div>
            <div :style="'background-image:url(' + pages12[169] + ')'"></div>
            <div :style="'background-image:url(' + pages12[170] + ')'"></div>
            <div :style="'background-image:url(' + pages12[171] + ')'"></div>
            <div :style="'background-image:url(' + pages12[172] + ')'"></div>
            <div :style="'background-image:url(' + pages12[173] + ')'"></div>
            <div :style="'background-image:url(' + pages12[174] + ')'"></div>
            <div :style="'background-image:url(' + pages12[175] + ')'"></div>
            <div :style="'background-image:url(' + pages12[176] + ')'"></div>
            <div :style="'background-image:url(' + pages12[177] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 10% " target="_blank"
                @click="openLink('https://www.instagram.com/miles.greenberg/')">@miles.greenberg</a>
            </div>
            <div :style="'background-image:url(' + pages12[178] + ')'"></div>
            <div :style="'background-image:url(' + pages12[179] + ')'"></div>
            <div :style="'background-image:url(' + pages12[180] + ')'"></div>
            <div :style="'background-image:url(' + pages12[181] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 9% " target="_blank"
                @click="openLink('https://www.instagram.com/tiwalecbo/')">@tiwalecbo</a>
            </div>
            <div :style="'background-image:url(' + pages12[182] + ')'"></div>
            <div :style="'background-image:url(' + pages12[183] + ')'"></div>
            <div :style="'background-image:url(' + pages12[184] + ')'">
              <a class="minilinks articles2" style="bottom: 8.6%; left: 4%; width: 10%;"
                @click.stop="audioI12.isPlaying ? pauseAudio(audioI12) : playAudio(audioI12)">
                Click to Play
              </a>             
            </div>
            <div :style="'background-image:url(' + pages12[185] + ')'"></div>
            <div :style="'background-image:url(' + pages12[186] + ')'"></div>
            <div :style="'background-image:url(' + pages12[187] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:51%; width: 8% " target="_blank"
                @click="openLink('https://www.instagram.com/jeandawsn/')">@jeandawsn</a>
            </div>
            <div :style="'background-image:url(' + pages12[188] + ')'">
              <a class="minilinks articles2" style="bottom:4.9%; left:50%; width: 18.5% " target="_blank"
                @click="openLink('https://www.instagram.com/1.5degrees_of_peace/')">@@1.5degrees_of_peace</a>
            </div>
            <div :style="'background-image:url(' + pages12[189] + ')'"></div>
            <div :style="'background-image:url(' + pages12[190] + ')'"></div>
            <div :style="'background-image:url(' + pages12[191] + ')'"></div>
            <div :style="'background-image:url(' + pages12[192] + ')'"></div>
            <div :style="'background-image:url(' + pages12[193] + ')'">
              <a class="minilinks articles2" style="bottom: 5%; right: 4%; width: 10%; "
              @click.prevent="onPlayerReadybanner03(media[157])">Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages12[194] + ')'"></div>
            <div :style="'background-image:url(' + pages12[195] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 10% " target="_blank"
                @click="openLink('https://www.instagram.com/thelindalindas/')">@thelindalindas</a>
            </div>
            <div :style="'background-image:url(' + pages12[196] + ')'"></div>
            <div :style="'background-image:url(' + pages12[197] + ')'"></div>
            <div :style="'background-image:url(' + pages12[198] + ')'"></div>
            <div :style="'background-image:url(' + pages12[199] + ')'"></div>
            <div :style="'background-image:url(' + pages12[200] + ')'"></div>
            <div :style="'background-image:url(' + pages12[201] + ')'">
              <a class="minilinks articles2" style="bottom: 25.4%; right: 4%; width: 10%; "
              @click.prevent="onPlayerReadybanner04(media[158])">Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages12[202] + ')'"></div>
            <div :style="'background-image:url(' + pages12[203] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 7%" target="_blank"
                @click="openLink('https://www.instagram.com/elyanna/')">@elyanna</a> </div>
            <div :style="'background-image:url(' + pages12[204] + ')'"> </div>
            <div :style="'background-image:url(' + pages12[205] + ')'">
              <a class="links articles2" style="top:34.8%; left:51.5%; width: 10%" target="_blank"
                @click="openLink('https://www.instagram.com/loganstacer/')">@loganstacer</a>
           </div>
            <div :style="'background-image:url(' + pages12[206] + ')'"></div>
            <div :style="'background-image:url(' + pages12[207] + ')'"></div>
            <div :style="'background-image:url(' + pages12[208] + ')'"></div>
            <div :style="'background-image:url(' + pages12[209] + ')'"></div>
            <div :style="'background-image:url(' + pages12[210] + ')'"></div>
            <div :style="'background-image:url(' + pages12[211] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 11%" target="_blank"
                @click="openLink('https://www.instagram.com/dillonst.bernard/')">@dillonst.bernard</a>
            </div>
            <div :style="'background-image:url(' + pages12[212] + ')'"></div>
            <div :style="'background-image:url(' + pages12[213] + ')'"></div>
            <div :style="'background-image:url(' + pages12[214] + ')'"></div>
            <div :style="'background-image:url(' + pages12[215] + ')'">
              <a
                class="links articles2"
                style="bottom: 7.8%;left:30%; width: 39.5%"
                target="_blank"
                @click="openBook"
              >CLICK HERE TO DOWNLOAD</a>
            </div>
            <div :style="'background-image:url(' + pages12[216] + ')'"></div>
            <div :style="'background-image:url(' + pages12[217] + ')'"></div>
            <div :style="'background-image:url(' + pages12[218] + ')'"></div>
            <div :style="'background-image:url(' + pages12[219] + ')'"></div>
            <div :style="'background-image:url(' + pages12[220] + ')'"></div>
            <div :style="'background-image:url(' + pages12[221] + ')'"></div>
            <div :style="'background-image:url(' + pages12[222] + ')'"></div>
            <div :style="'background-image:url(' + pages12[223] + ')'"></div>
            <div :style="'background-image:url(' + pages12[224] + ')'"></div>
            <div :style="'background-image:url(' + pages12[225] + ')'">
              <a class="minilinks articles2" style="top:39.3%; left:51%; width: 18%" target="_blank"
                @click="openLink('https://www.instagram.com/lauragomezjurado_/')">@lauragomezjurado_</a>
            </div>
            <div :style="'background-image:url(' + pages12[226] + ')'"></div>
            <div :style="'background-image:url(' + pages12[227] + ')'"></div>
            <div :style="'background-image:url(' + pages12[228] + ')'"></div>
            <div :style="'background-image:url(' + pages12[229] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 10%" target="_blank"
                @click="openLink('https://www.instagram.com/frias_daphne/')">@frias_daphne</a>
            </div>
            <div :style="'background-image:url(' + pages12[230] + ')'"></div>
            <div :style="'background-image:url(' + pages12[231] + ')'"></div>
            <div :style="'background-image:url(' + pages12[232] + ')'"></div>
            <div :style="'background-image:url(' + pages12[233] + ')'"></div>
            <div :style="'background-image:url(' + pages12[234] + ')'"></div>
            <div :style="'background-image:url(' + pages12[235] + ')'"></div>
            <div :style="'background-image:url(' + pages12[236] + ')'"></div>
            <div :style="'background-image:url(' + pages12[237] + ')'">
              <a class="minilinks articles2" style="bottom:4.5%; left:50.8%; width: 8%" target="_blank"
                @click="openLink('https://sungai.watch/')">Sungai Watch</a>
            </div>
            <div :style="'background-image:url(' + pages12[238] + ')'">
              <a class="minilinks articles2" style="bottom:5.2%; left:50.2%; width: 14%" target="_blank"
                @click="openLink('https://www.instagram.com/layapothunuri/')">@layapothunuri</a>
            </div>
            <div :style="'background-image:url(' + pages12[239] + ')'"></div>
            <div :style="'background-image:url(' + pages12[240] + ')'"></div>
            <div :style="'background-image:url(' + pages12[241] + ')'"></div>
            <div :style="'background-image:url(' + pages12[242] + ')'"></div>
            <div :style="'background-image:url(' + pages12[243] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 10%" target="_blank"
                @click="openLink('https://www.instagram.com/nicotheduffer/')">@nicotheduffer</a>
            </div>
            <div :style="'background-image:url(' + pages12[244] + ')'"></div>
            <div :style="'background-image:url(' + pages12[245] + ')'">
              <a class="minilinks articles2" style="top:34%; left:50.8%; width: 11%" target="_blank"
                @click="openLink('https://www.instagram.com/petok_pem/')">@petok_pem</a>
            </div>
            <div :style="'background-image:url(' + pages12[246] + ')'"></div>
            <div :style="'background-image:url(' + pages12[247] + ')'"></div>
            <div :style="'background-image:url(' + pages12[248] + ')'"></div>
            <div :style="'background-image:url(' + pages12[249] + ')'"></div>
            <div :style="'background-image:url(' + pages12[250] + ')'"></div>
            <div :style="'background-image:url(' + pages12[251] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 6%" target="_blank"
                @click="openLink('https://www.instagram.com/soapy.t/')">@soapy.t</a>
            </div>
            <div :style="'background-image:url(' + pages12[252] + ')'"></div>
            <div :style="'background-image:url(' + pages12[253] + ')'">
              <a class="minilinks articles2" style="bottom: 24.8%; right: 4%; width: 10%; "
              @click.prevent="onPlayerReadybanner05(media[159])">Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages12[254] + ')'"></div>
            <div :style="'background-image:url(' + pages12[255] + ')'">
              <a class="minilinks articles2" style="top:18%; left:51%; width: 9%" target="_blank"
                @click="openLink('https://www.instagram.com/shawonj/')">@shawonj</a>
            </div>
            <div :style="'background-image:url(' + pages12[256] + ')'"></div>
            <div :style="'background-image:url(' + pages12[257] + ')'"></div>
            <div :style="'background-image:url(' + pages12[258] + ')'"></div>
            <div :style="'background-image:url(' + pages12[259] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 13.4%" target="_blank"
                @click="openLink('https://www.instagram.com/hannahtraoregallery/')">@hannahtraoregallery</a>
            </div>
            <div :style="'background-image:url(' + pages12[260] + ')'"></div>
            <div :style="'background-image:url(' + pages12[261] + ')'"></div>
            <div :style="'background-image:url(' + pages12[262] + ')'"></div>
            <div :style="'background-image:url(' + pages12[263] + ')'"></div>
            <div :style="'background-image:url(' + pages12[264] + ')'"></div>
            <div :style="'background-image:url(' + pages12[265] + ')'">
              <a class="minilinks articles2" style="bottom:4.5%; left:50.8%; width: 10.5%" target="_blank"
                @click="openLink('https://www.instagram.com/thenehashukla/')">@thenehashukla</a>
            </div>
            <div :style="'background-image:url(' + pages12[266] + ')'"></div>
            <div :style="'background-image:url(' + pages12[267] + ')'">
              <a class="minilinks articles2" style="top:20.2%; left:51%; width: 13%" target="_blank"
                @click="openLink('https://www.instagram.com/rethinkwords/')">@rethinkwords</a>
            </div>
            <div :style="'background-image:url(' + pages12[268] + ')'"></div>
            <div :style="'background-image:url(' + pages12[269] + ')'"></div>
            <div :style="'background-image:url(' + pages12[270] + ')'"></div>
            <div :style="'background-image:url(' + pages12[271] + ')'"></div>
            <div :style="'background-image:url(' + pages12[272] + ')'"></div>
            <div :style="'background-image:url(' + pages12[273] + ')'"> </div>
            <div :style="'background-image:url(' + pages12[274] + ')'"></div>
            <div :style="'background-image:url(' + pages12[275] + ')'"></div>
            <div :style="'background-image:url(' + pages12[276] + ')'">
              <a class="minilinks articles2" style="bottom:4.5%; left:50.8%; width: 11.5%" target="_blank"
                @click="openLink('https://www.instagram.com/aurelhaizeodogbo/')">@aurelhaizeodogbo</a>
            </div>
            <div :style="'background-image:url(' + pages12[277] + ')'"></div>
            <div :style="'background-image:url(' + pages12[278] + ')'"></div>
            <div :style="'background-image:url(' + pages12[279] + ')'">
              <a class="minilinks articles2" style="bottom:22.6%; right:21.5%; width: 11%" target="_blank"
                @click="openLink('https://www.thombrowne.com/')">thombrowne.com</a>
              <a class="minilinks articles2" style="bottom:21.2%; right:18%; width: 4%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:19.6%; right:5%; width: 6.5%" target="_blank"
                @click="openLink('https://turnbullandasser.com/')">turnbullandasser.com</a>
              <a class="minilinks articles2" style="bottom:18%; right:24%; width: 6%" target="_blank"
                @click="openLink('https://turnbullandasser.com/')">turnbullandasser.com</a>
              <a class="minilinks articles2" style="bottom:16.4%; right:18.5%; width: 10%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
              <a class="minilinks articles2" style="bottom:16.4%; right:5%; width: 4%" target="_blank"
                @click="openLink('https://www.thombrowne.com/')">thom</a>
              <a class="minilinks articles2" style="bottom:14.8%; right:26%; width: 6%" target="_blank"
                @click="openLink('https://www.thombrowne.com/')">thombrowne.com</a>
              <a class="minilinks articles2" style="bottom:11.8%; right:20.2%; width: 4%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:10.1%; right:18.4%; width: 6%" target="_blank"
                @click="openLink('https://www.burton.co.uk/')">burton.co.uk</a>
              <a class="minilinks articles2" style="bottom:8.4%; right:16.5%; width: 4%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:6.9%; right:5%; width: 13%" target="_blank"
                @click="openLink('https://turnbullandasser.com/')">turnbullandasser.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[280] + ')'">
              <a class="minilinks articles2" style="bottom:13.2%; left:11.2%; width:10%" target="_blank"
                @click="openLink('https://simonerocha.com/')">simonerocha.com</a>
                <a class="minilinks articles2" style="bottom:8.4%; left:17.8%; width: 5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
                <a class="minilinks articles2" style="bottom:6.9%; left:15.6%; width:4%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
            </div>
            <div :style="'background-image:url(' + pages12[281] + ')'"></div>
            <div :style="'background-image:url(' + pages12[282] + ')'"></div>
            <div :style="'background-image:url(' + pages12[283] + ')'">
              <a class="minilinks articles2" style="bottom:6.9%; right:3%; width: 4.5%" target="_blank"
                @click="openLink('https://www.gucci.com/')">gucci.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[284] + ')'">
              <a class="minilinks articles2"  target="_blank" style="bottom:16.2%; left:15.6%; width: 6.5%" 
                @click="openLink('https://www.miumiu.com/')">miumiu.com</a>
              <a class="minilinks articles2" style="bottom:13.2%; left:15.5%; width: 4%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:10%; left:10%; width: 4%" target="_blank"
                @click="openLink('https://www.youmustcreate.com/')">youmustcreate.com</a>
                <a class="minilinks articles2" style="bottom:8.4%; left:19%; width:4.5%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
                <a class="minilinks articles2" style="bottom:6.9%; left:14%; width: 5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[285] + ')'">
              <a class="minilinks articles2"  target="_blank" style="bottom:11.6%; right:6%; width: 5%" 
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
              <a class="minilinks articles2"  target="_blank" style="bottom:10%; right:22.8%; width: 4.5%" 
                @click="openLink('https://www.cenci.co.uk/')">Cenci</a>
              <a class="minilinks articles2" style="bottom:10%; right:6%; width: 4%" target="_blank"
                @click="openLink('https://www.miumiu.com/')">miumiu.com</a>
              <a class="minilinks articles2" style="bottom:8.4%; right:20.6%; width: 4%" target="_blank"
                @click="openLink('https://www.miumiu.com/')">miumiu.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[286] + ')'">
              <a class="minilinks articles2"  target="_blank" style="bottom:6.8%; left:13%; width: 6%" 
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
            </div>
            <div :style="'background-image:url(' + pages12[287] + ')'">
              <a class="minilinks articles2" style="bottom:10%; right:5%; width: 10%" target="_blank"
              @click="openLink('https://www.thombrowne.com/')">thombrowne.com</a>
              <a class="minilinks articles2" style="bottom:6.9%; right:5%; width: 4.5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[288] + ')'">
              <a class="minilinks articles2"  target="_blank" style="bottom:6.8%; left:8.5%; width: 6%" 
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
            </div>
            <div :style="'background-image:url(' + pages12[289] + ')'">
              <a class="minilinks articles2"  target="_blank" style="bottom:29%; right:20%; width: 9.5%"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
              <a class="minilinks articles2" style="bottom:27.4%; right:13%; width:4%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:25.8%; right:10.2%; width: 10%" target="_blank"
              @click="openLink('https://www.thombrowne.com/')">thombrowne.com</a>
              <a class="minilinks articles2" style="bottom:22.8%; right:15.2%; width: 13%" target="_blank"
                @click="openLink('https://turnbullandasser.com/')">turnbullandasser.com
              </a>
              <a class="minilinks articles2"  target="_blank" style="bottom:21.2%; right:11%; width: 9%" 
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
              <a class="minilinks articles2" style="bottom:19.4%; right:16%; width:10%" target="_blank"
                @click="openLink('https://www.thombrowne.com/')">thombrowne.com</a>
              <a class="minilinks articles2" style="bottom:16.4%; right:6%; width:9%" target="_blank"
                @click="openLink('https://turnbullandasser.com/')">turnbullandasser.com
              </a>
              <a class="minilinks articles2" style="bottom:14.8%; right:26.6%; width: 4.5%" target="_blank"
                @click="openLink('https://turnbullandasser.com/')">turnbullandasser.com
              </a>
              <a class="minilinks articles2" style="bottom:11.6%; right:19.5%; width: 5.6%" target="_blank"
                @click="openLink('https://www.burton.co.uk/')">burton.co.uk</a>
              <a class="minilinks articles2" style="bottom:8.5%; right:24.8%; width: 4.8%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:6.9%; right:7%; width: 13%" target="_blank"
                @click="openLink('https://turnbullandasser.com/')">turnbullandasser.com
              </a>
            </div>
            <div :style="'background-image:url(' + pages12[290] + ')'">
              <a class="minilinks articles2" style="bottom:10%; left:21.5%; width: 4.5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:6.9%; left: 8%; width: 10.5%" target="_blank"
                @click="openLink('https://simonerocha.com/')">simonerocha.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[291] + ')'"></div>
            <div :style="'background-image:url(' + pages12[292] + ')'">
              <a class="minilinks articles2" style="top:13.2%; left:18.8%; width: 4.5%" target="_blank"
                @click="openLink('https://www.dior.com/')">dior.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[293] + ')'">
              <a class="minilinks articles2" style="bottom:14.8%; right:10%; width: 4.5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
                <a class="minilinks articles2"  target="_blank" style="bottom:13.2%; right:16.8%; width: 5%" 
                @click="openLink('https://www.cenci.co.uk/')">Cenci</a>
                <a class="minilinks articles2" style="bottom:10%; right:22.8%; width: 4.5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
                <a class="minilinks articles2" style="bottom:6.9%; right:22.8%; width: 4.5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
                <a class="minilinks articles2"  target="_blank" style="bottom:6.9%; right:5%; width: 5%" 
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
            </div>
            <div :style="'background-image:url(' + pages12[294] + ')'">
              <a class="minilinks articles2" style="bottom:10%; left:19.8%; width: 9.2%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
              <a class="minilinks articles2" style="bottom:8.4%; left:15.8%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/')">miumiu.com</a>
              <a class="minilinks articles2" style="bottom:6.9%; left:17%; width: 5%" target="_blank"
                @click="openLink('https://www.chloe.com/')">chloe.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[295] + ')'">
              <a class="minilinks articles2"  target="_blank" style="bottom:6.9%; right:19.8%; width: 5%" 
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
              <a class="minilinks articles2"  target="_blank" style="bottom:6.9%; right:5%; width: 5%" 
                @click="openLink('https://www.apc-us.com/')">apc-us</a>
            </div>
            <div :style="'background-image:url(' + pages12[296] + ')'">
              <a class="minilinks articles2" style="bottom:8.4%; left:13.5%; width: 10%" target="_blank"
                @click="openLink('https://www.thombrowne.com/')">thombrowne.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[297] + ')'">
              <a class="minilinks articles2" style="bottom:16%; right:14.5%; width: 10%" target="_blank"
                @click="openLink('https://www.thombrowne.com/')">thombrowne.com</a>
                <a class="minilinks articles2" style="bottom:13.2%; right:23.5%; width: 5%" target="_blank"
                @click="openLink('https://www.chloe.com/')">chloe.com</a>
                <a class="minilinks articles2" style="bottom:10%; right:20.8%; width: 4%" target="_blank"
                @click="openLink('https://www.dior.com/')">dior.com</a>
                <a class="minilinks articles2" style="bottom:8.4%; right:25.8%; width: 5%" target="_blank"
                @click="openLink('https://www.gucci.com/')">gucci.com</a>
                <a class="minilinks articles2" style="bottom:8.4%; right:5%; width: 5%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
                <a class="minilinks articles2" style="bottom:6.9%; right:25%; width: 5%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
                <a class="minilinks articles2" style="bottom:6.9%; right:5%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/')">miumiu.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[298] + ')'">
              <a class="minilinks articles2" style="bottom:8.4%; left:14.5%; width: 5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:6.9%; left:12.5%; width: 5%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
            </div>
            <div :style="'background-image:url(' + pages12[299] + ')'"></div>
            <div :style="'background-image:url(' + pages12[300] + ')'">
              <a class="minilinks articles2" style="bottom:28%; left:41%; width: 17.5%" target="_blank"
                @click="openLink('https://www.instagram.com/angelica.jopling/?hl=en')">@angelica.jopling</a>
            </div>
            <div :style="'background-image:url(' + pages12[301] + ')'">
               <a class="minilinks articles2" style="bottom:11.5%; left:45%; width: 10.8%" target="_blank"
                @click="openLink('https://www.instagram.com/mistkyd/?hl=en')">@mistkyd</a>
            </div>
            <div :style="'background-image:url(' + pages12[302] + ')'">
               <a class="minilinks articles2" style="bottom:25.2%; left:43%; width: 13%" target="_blank"
                @click="openLink('https://www.instagram.com/nellmescal/')">@nellmescal</a>
            </div>
            <div :style="'background-image:url(' + pages12[303] + ')'">
               <a class="minilinks articles2" style="bottom:19.5%; left:43%; width: 14.8%" target="_blank"
                @click="openLink('https://www.instagram.com/kvstheworld/')">@kvstheworld</a>
            </div>
            <div :style="'background-image:url(' + pages12[304] + ')'">
               <a class="minilinks articles2" style="bottom:5.9%; left:39.5%; width: 20%" target="_blank"
                @click="openLink('https://www.instagram.com/josephkinggeorgey/')">@josephkinggeorgey</a>
            </div>
            <div :style="'background-image:url(' + pages12[305] + ')'">
              <a class="minilinks articles2" style="bottom:12.6%; left:40.5%; width: 20%" target="_blank"
                @click="openLink('https://www.instagram.com/joseph_.shepherd/')">@joseph_.shepherd</a>
            </div>
            <div :style="'background-image:url(' + pages12[306] + ')'"></div>
            <div :style="'background-image:url(' + pages12[307] + ')'"></div>
            <div :style="'background-image:url(' + pages12[308] + ')'"></div>
            <div :style="'background-image:url(' + pages12[309] + ')'">
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 8%" target="_blank"
                @click="openLink('https://www.balenciaga.com/')">balenciaga.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[310] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:3%; width: 19%" target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')">alexandermcqueen.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[311] + ')'">
              <a class="minilinks articles2" style="bottom:10.2%; right:6%; width: 13%" target="_blank"
                @click="openLink('https://adriancashmere.com/')">adriancashmere.com</a>
              <a class="minilinks articles2" style="bottom:8.7%; right:9%; width: 10%" target="_blank"
                @click="openLink('https://www.calvinklein.com')">calvinklein.com</a>
              <a class="minilinks articles2" style="bottom:7%; right:3%; width: 11%" target="_blank"
                @click="openLink('https://isabelmarant.com/')">isabelmarant.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 6%" target="_blank"
                @click="openLink('https://www.ghbass.com/')">ghbass.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[312] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:9%; width: 7%" target="_blank"
                @click="openLink('https://www.moschino.com/')">moschino.com
              </a>
            </div>
            <div :style="'background-image:url(' + pages12[313] + ')'"></div>
            <div :style="'background-image:url(' + pages12[314] + ')'">
              <a class="minilinks articles2" style="bottom:10%; left:18.5%; width:4%" target="_blank"
                @click="openLink('https://www.dior.com/')">dior.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:14%; width:5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[315] + ')'"></div>
            <div :style="'background-image:url(' + pages12[316] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:20%; width: 8.5%" target="_blank"
                @click="openLink('https://www.balenciaga.com/')">balenciaga.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:17.2%; width: 6%" target="_blank"
                @click="openLink('https://www.h2erg.co.uk/')">h2erg.co.uk</a>
            </div>
            <div :style="'background-image:url(' + pages12[317] + ')'">
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 10.5%" target="_blank"
                @click="openLink('https://www.louisvuitton.com/')">louisvuitton.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[318] + ')'"></div>
            <div :style="'background-image:url(' + pages12[319] + ')'">
              <a class="minilinks articles2" style="bottom:8.6%; right:3%; width: 7.5%" target="_blank"
                @click="openLink('https://www.dior.com/')">Dior</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 4%" target="_blank"
                @click="openLink('https://www.numeroventuno.com/')">n21</a>
            </div>
            <div :style="'background-image:url(' + pages12[320] + ')'"></div>
            <div :style="'background-image:url(' + pages12[321] + ')'">
              <a class="minilinks articles2" style="bottom:8.6%; right:3%; width: 8%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">ralphlauren.com</a>
              <a class="minilinks articles2" style="bottom:7%; right:17%; width: 5%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">ralphlauren</a>
                <a class="minilinks articles2" style="bottom:5.6%; right:11%; width: 8%" target="_blank"
                @click="openLink('https://www.franceso.co.uk/')">franceso.co.uk</a>
                <a class="minilinks articles2" style="bottom:4%; right:3%; width: 10%" target="_blank"
                @click="openLink('https://elliotrhodes.com/')">elliotrhodes.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[322] + ')'">
              <a class="minilinks articles2" style="bottom:8.6%; left:20.4%; width: 6%" target="_blank"
                @click="openLink('https://miharayasuhiro.jp/')">miharayasuhiro.jp</a>
              <a class="minilinks articles2" style="bottom:7%; left:3%; width: 12.5%" target="_blank"
                @click="openLink('https://miharayasuhiro.jp/')">miharayasuhiro.jp</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 4%" target="_blank"
                @click="openLink('https://www.ariesarise.com/')">ariesarise.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:19%; width: 6.5%" target="_blank"
                @click="openLink('https://www.h2erg.co.uk/')">h2erg.co.uk</a>
              <a class="minilinks articles2" style="bottom:4%; left:12.2%; width: 9.5%" target="_blank"
                @click="openLink('https://www.drmartens.com/')">drmartens.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[323] + ')'">
              <a class="minilinks articles2" style="top:8.6%; right:3%; width: 4.2%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[324] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:8.5%; width: 5.5%" target="_blank"
                @click="openLink('https://www.chanel.com/')">chanel.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[325] + ')'">
              <a class="minilinks articles2" style="top:7%; right:3%; width: 17.5%" target="_blank"
                @click="openLink('https://www.maisonmargiela.com/')">maisonmargiela.com</a>
              <a class="minilinks articles2" style="top:10%; right:10%; width: 11%" target="_blank"
                @click="openLink('https://karolinevitto.com/')">karolinevitto.com</a>
              <a class="minilinks articles2" style="top:11.8%; right:3%; width: 11%" target="_blank"
                @click="openLink('https://carlospenna.design/')">carlospenna.design</a>
              <a class="minilinks articles2" style="top:13.3%; right:3%; width: 11%" target="_blank"
                @click="openLink('https://karolinevitto.com/')">karolinevitto.com </a>
            </div>
            <div :style="'background-image:url(' + pages12[326] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:3%; width: 18.5%" target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')">alexandermcqueen.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[327] + ')'"></div>
            <div :style="'background-image:url(' + pages12[328] + ')'">
              <a class="minilinks articles2" style="bottom:8.7%; left:18.6%; width: 5%" target="_blank"
                @click="openLink('https://www.gucci.com/')">gucci.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:12.5%; width: 7.5%" target="_blank"
                @click="openLink('https://www.dior.com/')">dior.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[329] + ')'"></div>
            <div :style="'background-image:url(' + pages12[330] + ')'">
              <a class="minilinks articles2" style="bottom:10.1%; left:3%; width: 8%" target="_blank"
                @click="openLink('https://www.balenciaga.com/')">balenciaga.com</a>
              <a class="minilinks articles2" style="bottom:8.6%; left:15%; width: 4%" target="_blank"
                @click="openLink('https://www.r13.com/')">r13.com</a>
              <a class="minilinks articles2" style="bottom:5.6%; left:3%; width: 5%" target="_blank"
                @click="openLink('https://lekilt.co.uk/')">lekilt.co.uk</a>
              <a class="minilinks articles2" style="bottom:4%; left:3%; width: 8%" target="_blank"
                @click="openLink('https://www.franceso.co.uk/')">franceso.co.uk</a>
              </div>
            <div :style="'background-image:url(' + pages12[331] + ')'"></div>
            <div :style="'background-image:url(' + pages12[332] + ')'"></div>
            <div :style="'background-image:url(' + pages12[333] + ')'"></div>
            <div :style="'background-image:url(' + pages12[334] + ')'"></div>
            <div :style="'background-image:url(' + pages12[335] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:39%; width: 10.5%" target="_blank"
                @click="openLink('https://www.louisvuitton.com/')">louisvuitton.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:36%; width: 4%" target="_blank"
                @click="openLink('https://bless-service.de/')">bless-service.de</a>
            </div>
            <div :style="'background-image:url(' + pages12[336] + ')'">
              <a class="minilinks articles2" style="bottom:7%; right:42.8%; width: 5%" target="_blank"
                @click="openLink('https://kolor.jp/')">kolor.jp</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:31.5%; width: 8%" target="_blank"
                @click="openLink('https://www.dsquared2.com/')">dsquared2.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:30.8%; width: 6.5%" target="_blank"
                @click="openLink('https://www.fruit.com/')">fruit.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:30%; width: 7.5%" target="_blank"
                @click="openLink('https://www.fruit.com/')">fruit.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:31.5%; width: 7%" target="_blank"
                @click="openLink('https://www.converse.com/')">converse.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[337] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:34.5%; width: 7%" target="_blank"
                @click="openLink('https://www.givenchy.com/')">givenchy.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:34.5%; width: 12%" target="_blank"
                @click="openLink('https://www.thenorthface.com/')">thenorthface.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[338] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:35.8%; width: 8%" target="_blank"
                @click="openLink('https://www.balenciaga.com/')">balenciaga</a>
              <a class="minilinks articles2" style="bottom:4%; right:37.5%; width: 7%" target="_blank"
                @click="openLink('https://www.champion.com/')">champion.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[339] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:32%; width: 4%" target="_blank"
                @click="openLink('https://bless-service.de/')">bless-service.de</a>
              <a class="minilinks articles2" style="bottom:4%; left:45%; width: 6%" target="_blank"
                @click="openLink('https://www.hanes.com/')">hanes.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:33.5%; width: 6%" target="_blank"
                @click="openLink('https://www.miumiu.com/')">miumiu.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[340] + ')'">
              <a class="minilinks articles2" style="bottom:7.1%; right:39.5%; width: 7%" target="_blank"
                @click="openLink('https://www.givenchy.com/')">givenchy.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:37%; width: 14%" target="_blank"
                @click="openLink('https://www.fruit.com/')">fruit.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:32%; width: 5%" target="_blank"
                @click="openLink('https://bless-service.de/')">bless-service.de</a>
              <a class="minilinks articles2" style="bottom:4%; right:34%; width: 12%" target="_blank"
                @click="openLink('https://www.thenorthface.com/')">thenorthface.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[341] + ')'">
              <a class="links articles2" style="bottom:4%; right:40%; width: 19%" target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')">alexandermcqueen.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[342] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:41.5%; width: 7%" target="_blank"
                @click="openLink('https://www.dior.com/')">dior.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:30%; width: 15.5%" target="_blank"
                @click="openLink('https://shop.doverstreetmarket.com/')">shop.doverstreetmarket.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:31%; width: 4.5%" target="_blank"
                @click="openLink('https://www.nike.com/')">nike.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[343] + ')'">
              <a class="minilinks articles2" style="bottom:4%; right:34%; width: 16%" target="_blank"
                @click="openLink('https://shop.doverstreetmarket.com/')">shop.doverstreetmarket.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[344] + ')'"></div>
            <div :style="'background-image:url(' + pages12[345] + ')'"> 
                <a class="minilinks articles2" style="bottom:4%; right:3%; width: 9%" target="_blank"
                @click="openLink('https://ouest.world/')">Ouest.world</a>
            </div>
            <div :style="'background-image:url(' + pages12[346] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:34.5%; width: 13.2%" target="_blank"
                @click="openLink('https://www.dolcegabbana.com/')">dolcegabbana.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:42%; width: 5%" target="_blank"
                @click="openLink('https://www.stussy.com/')">stussy.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:33%; width: 7%" target="_blank"
                @click="openLink('https://www.havaianas.com/')">havaianas.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[347] + ')'"></div>
            <div :style="'background-image:url(' + pages12[348] + ')'"></div>
            <div :style="'background-image:url(' + pages12[349] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:31%; width: 4.5%" target="_blank"   
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:41%; width: 7.5%" target="_blank"
              @click="openLink('https://www.champion.com/')">champion.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[350] + ')'"></div>
            <div :style="'background-image:url(' + pages12[351] + ')'"></div>
            <div :style="'background-image:url(' + pages12[352] + ')'"></div>
            <div :style="'background-image:url(' + pages12[353] + ')'">
              <a class="minilinks articles2" style="bottom:8.7%; right:3%; width: 7.5%" target="_blank"
              @click="openLink('https://www.dior.com/')">Dior.com</a>
              <a class="minilinks articles2" style="bottom:7%; right:23%; width: 5%" target="_blank"
              @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:31.5%; width: 9.5%" target="_blank"
              @click="openLink('https://www.lucybarlow.com/')">lucybarlow.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 5%" target="_blank"
              @click="openLink('https://www.kenzo.com/')">kenzo.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:25.5%; width: 4%" target="_blank"
              @click="openLink('https://www.fila.com/')">fila.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 8%" target="_blank"
              @click="openLink('https://www.longchamp.com/')">longchamp.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[354] + ')'">
              <a class="minilinks articles2" style="bottom:22.8%; left:3%; width: 3%" target="_blank"
                @click="openLink('https://www.fila.com/')">fila</a>
              <a class="minilinks articles2" style="bottom:22.8%; left:16%; width: 7%" target="_blank"
                @click="openLink('https://us.burberry.com/')">burberry.com</a>
              <a class="minilinks articles2" style="bottom:21.3%; left:5%; width: 9%" target="_blank"
              @click="openLink('https://www.lucybarlow.com/')">lucybarlow.com</a>
              <a class="minilinks articles2" style="bottom:19.8%; left:3%; width: 10%" target="_blank"
              @click="openLink('https://www.louisvuitton.com/')">louisvuitton.com</a>
              <a class="minilinks articles2" style="bottom:18.1%; left:3%; width: 6.5%" target="_blank"
                @click="openLink('https://us.burberry.com/')">burberry.com</a>
              <a class="minilinks articles2" style="bottom:18.1%; left:19%; width: 5%" target="_blank"
                @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="bottom:16.6%; left:3%; width: 9.4%" target="_blank"
              @click="openLink('https://www.lucybarlow.com/')">lucybarlow.com</a>
              <a class="minilinks articles2" style="bottom:16.6%; left:22.2%; width: 7%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:15%; left:3%; width: 10%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:13.4%; left:22%; width: 4.5%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:8.7%; left:3%; width: 8%" target="_blank"
                @click="openLink('https://www.dsquared2.com/')">dsquared2.com</a>
              <a class="minilinks articles2" style="bottom:7%; left:13%; width: 5.5%" target="_blank"
              @click="openLink('https://www.shop-msgm.com/')">msgm.com</a>
              <a class="minilinks articles2" style="bottom:7%; left:29.2%; width: 4%" target="_blank"
              @click="openLink('https://www.dior.com/')">Dior.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 4%" target="_blank"
              @click="openLink('https://www.dior.com/')">Dior.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:20%; width: 11%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:3%; width: 5.5%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[355] + ')'"></div>
            <div :style="'background-image:url(' + pages12[356] + ')'"></div>
            <div :style="'background-image:url(' + pages12[357] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 3%" target="_blank"
              @click="openLink('https://www.fila.com/')">fila</a>
            </div>
            <div :style="'background-image:url(' + pages12[358] + ')'">
              <a class="minilinks articles2" style="top:7%; left:4.5%; width: 8%" target="_blank"
              @click="openLink('https://www.dsquared2.com/')">dsquared2.com</a>
              <a class="minilinks articles2" style="top:8.6%; left:4.5%; width: 10%" target="_blank"
              @click="openLink('https://martine-rose.com/')">martine</a>
              <a class="minilinks articles2" style="top:10.1%; left:8.5%; width: 10.5%" target="_blank"
              @click="openLink('https://www.louisvuitton.com/')">louisvuitton.com</a>
              <a class="minilinks articles2" style="top:11.7%; left:12.5%; width: 5%" target="_blank"
              @click="openLink('https://www.adidas.com/')">adidas.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[359] + ')'">
              <a class="minilinks articles2" style="bottom:8.7%; right:13%; width: 8%" target="_blank"
              @click="openLink('https://www.dior.com/')">Dior.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:12.5%; width: 4.5%" target="_blank"
              @click="openLink('https://www.kenzo.com/')">kenzo.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 9%" target="_blank"
              @click="openLink('https://www.lucybarlow.com/')">lucybarlow.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[360] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:8%; width: 11%" target="_blank"
                @click="openLink('https://www.louisvuitton.com/')">louisvuitton.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:10.8%; width: 5%" target="_blank"
                @click="openLink('https://www.gucci.com/')">gucci.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[361] + ')'">
              <a class="minilinks articles2" style="top:7.2%; right:16%; width: 4%" target="_blank"
                @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="top:8.7%; right:8%; width: 11.5%" target="_blank"
              @click="openLink('https://www.gentlemonster.com/')">gentlemonster.com</a>
              <a class="minilinks articles2" style="top:10.2%; right:3%; width: 4%" target="_blank"
              @click="openLink('https://www.rokeratelier.com/')">roker</a>
            </div>
            <div :style="'background-image:url(' + pages12[362] + ')'">
              <a class="minilinks articles2" style="top:7%; left:5%; width: 5%" target="_blank"
              @click="openLink('https://us.burberry.com/')">burberry.com</a>
              <a class="minilinks articles2" style="top:7%; left:20%; width: 6%" target="_blank"
                @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="top:8.5%; left:11%; width: 10%" target="_blank"
              @click="openLink('https://www.lucybarlow.com/')">lucybarlow.com</a>
              <a class="minilinks articles2" style="top:10.1%; left:12%; width: 13%" target="_blank"
                @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="top:11.7%; left:3%; width: 8%" target="_blank"
                @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="top:11.7%; left:19%; width: 5%" target="_blank"
              @click="openLink('https://www.rokeratelier.com/')">roker</a>
              <a class="minilinks articles2" style="top:16.5%; left:18.6%; width: 6%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[363] + ')'"></div>
            <div :style="'background-image:url(' + pages12[364] + ')'">
              <a class="minilinks articles2" style="top:7%; left:18%; width: 5%" target="_blank"
              @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="top:10.2%; left:3%; width: 3%" target="_blank"
              @click="openLink('https://www.fila.com/')">fila.com</a>
              <a class="minilinks articles2" style="top:10.2%; left:16%; width: 7%" target="_blank"
              @click="openLink('https://us.burberry.com/')">burberry.com</a>
              <a class="minilinks articles2" style="top:11.7%; left:10%; width: 10%" target="_blank"
              @click="openLink('https://www.lucybarlow.com/')">lucybarlow.com</a>
              <a class="minilinks articles2" style="top:13.3%; left:12.5%; width: 10.5%" target="_blank"
              @click="openLink('https://www.louisvuitton.com/')">louisvuitton.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[365] + ')'">
              <a class="minilinks articles2" style="bottom:8.6%; right:3%; width: 5%" target="_blank"
              @click="openLink('https://www.kenzo.com/')">kenzo.com</a>
              <a class="minilinks articles2" style="bottom:7%; right:19%; width: 3%" target="_blank"
              @click="openLink('https://www.fila.com/')">fila.com</a>
              <a class="minilinks articles2" style="bottom:7%; right:3%; width: 5%" target="_blank"
              @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:11%; width: 8.5%" target="_blank"
              @click="openLink('https://www.longchamp.com/')">longchamp.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:20%; width: 8%" target="_blank"
              @click="openLink('https://www.dior.com/')">Dior.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 6.5%" target="_blank"
              @click="openLink('https://us.burberry.com/')">burberry.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[366] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:4.5%; width: 5%" target="_blank"
              @click="openLink('https://www.gucci.com/')">gucci.com
            </a>
              <a class="minilinks articles2" style="bottom:5.5%; left:18%; width: 5%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:3%; width: 11.5%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[367] + ')'">
              <a class="minilinks articles2" style="bottom:29.2%; right:12.6%; width: 5%" target="_blank"
              @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="bottom:27.8%; right:21.5%; width: 5%" target="_blank"
              @click="openLink('https://www.shop-msgm.com/')">msgm.com</a>
              <a class="minilinks articles2" style="bottom:26%; right:12%; width: 9.5%" target="_blank"
              @click="openLink('https://www.lucybarlow.com/')">lucybarlow.com</a>
              <a class="minilinks articles2" style="bottom:24.5%; right:20%; width: 5%" target="_blank"
              @click="openLink('https://www.rokeratelier.com/')">rokeratelier.com</a>
              <a class="minilinks articles2" style="bottom:22.8%; right:16%; width: 5%" target="_blank"
              @click="openLink('https://www.kenzo.com/')">kenzo.com</a>
              <a class="minilinks articles2" style="bottom:22.8%; right:7%; width: 4%" target="_blank"
              @click="openLink('https://www.fila.com/')">fila.com</a>
              <a class="minilinks articles2" style="bottom:21.3%; right:15%; width: 5%" target="_blank"
              @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="bottom:19.8%; right:17%; width: 8%" target="_blank"
              @click="openLink('https://www.longchamp.com/')">longchamp.com</a>
              <a class="minilinks articles2" style="bottom:19.8%; right:3%; width: 5%" target="_blank"
              @click="openLink('https://www.dior.com/')">Dior.com</a>
              <a class="minilinks articles2" style="bottom:18.2%; right:20%; width: 4%" target="_blank"
              @click="openLink('https://www.dior.com/')">Dior</a>
              <a class="minilinks articles2" style="bottom:18.2%; right:3%; width: 7%" target="_blank"
              @click="openLink('https://us.burberry.com/')">burberry.com</a>
              <a class="minilinks articles2" style="bottom:15%; right:17%; width: 5%" target="_blank"
              @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="bottom:13.5%; right:13%; width: 12%" target="_blank"
              @click="openLink('https://www.gentlemonster.com/')">gentlemonster.com</a>
              <a class="minilinks articles2" style="bottom:11.9%; right:7%; width: 17%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:10.2%; right:13.5%; width: 5%" target="_blank"
              @click="openLink('https://www.rokeratelier.com/')">rokeratelier.com</a>
              <a class="minilinks articles2" style="bottom:8.7%; right:12.5%; width: 5%" target="_blank"
              @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="minilinks articles2" style="bottom:7.1%; right:19.5%; width: 5%" target="_blank"
              @click="openLink('https://www.gucci.com/')">gucci.com</a>
              <a class="minilinks articles2" style="bottom:7.1%; right:3%; width: 6%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:16.4%; width: 10%" target="_blank"
              @click="openLink('https://www.celine.com/')">celine.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 7%" target="_blank"
              @click="openLink('https://www.dior.com/')">Dior.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[368] + ')'"></div>
            <div :style="'background-image:url(' + pages12[369] + ')'"></div>
            <div :style="'background-image:url(' + pages12[370] + ')'"></div>
            <div :style="'background-image:url(' + pages12[371] + ')'">
              <a class="minilinks articles2" style="bottom:7%; right:11%; width: 5%" target="_blank"
              @click="openLink('https://www.loewe.com/')">loewe.com</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:6%; width: 15%" target="_blank"
              @click="openLink('https://www.florentinaleitner.com/')">florentinaleitner.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 9%" target="_blank"
              @click="openLink('https://milomaria.com/')">milomaria.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[372] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:8.5%; width: 5%" target="_blank"
                @click="openLink('https://shop.diesel.com/')">diesel.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[373] + ')'"></div>
            <div :style="'background-image:url(' + pages12[374] + ')'"></div>
            <div :style="'background-image:url(' + pages12[375] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:5%; width: 6%" target="_blank"
              @click="openLink('https://www.chanel.com/')">chanel.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[376] + ')'">
              <a class="minilinks articles2" style="bottom:8.6%; left:5%; width: 12%" target="_blank"
              @click="openLink('https://www.dolcegabbana.com/')">dolcegabbana.com</a> </div>
            <div :style="'background-image:url(' + pages12[377] + ')'"></div>
            <div :style="'background-image:url(' + pages12[378] + ')'">
              <a class="minilinks articles2" style="bottom:10.2%; left:13%" target="_blank"
              @click="openLink('https://us.burberry.com/')">burberry.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:18%" target="_blank"
              @click="openLink('https://www.dior.com/')">dior.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[379] + ')'"></div>
            <div :style="'background-image:url(' + pages12[380] + ')'">
              <a class="links articles2" style="bottom:4%; left:13.5%; width:5%" target="_blank"
              @click="openLink('https://www.prada.com/')">prada.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[381] + ')'"></div>
            <div :style="'background-image:url(' + pages12[382] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:13.5%; width: 6%" target="_blank"
              @click="openLink('https://www.chanel.com/')">chanel.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[383] + ')'"></div>
            <div :style="'background-image:url(' + pages12[384] + ')'"></div>
            <div :style="'background-image:url(' + pages12[385] + ')'">
              <a class="minilinks articles2" style="bottom:11.7%; right:19.5%; width: 6%" target="_blank"
              @click="openLink('https://www.loewe.com/')">loewe.com</a>
              <a class="minilinks articles2" style="bottom:11.7%; right:3%; width: 8.5%" target="_blank"
              @click="openLink('https://www.florentinaleitner.com/')">florentinaleitner.com</a>
              <a class="minilinks articles2" style="bottom:10.2%; right:14.8%; width: 6%" target="_blank"
              @click="openLink('https://www.florentinaleitner.com/')">florentinaleitner.com</a>
              <a class="minilinks articles2" style="bottom:8.6%; right:13%; width: 9%" target="_blank"
              @click="openLink('https://milomaria.com/')">milomaria.com</a>
              <a class="minilinks articles2" style="bottom:8.6%; right:3%; width: 4%" target="_blank"
              @click="openLink('https://www.nike.com/')">nike.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 19%" target="_blank"
              @click="openLink('https://www.alexandermcqueen.com/')">alexandermcqueen.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[386] + ')'"></div>
            <div :style="'background-image:url(' + pages12[387] + ')'">
              <a class="minilinks articles2" style="bottom:4%; right:5%; width: 6%" target="_blank"
              @click="openLink('https://www.hermes.com/')">hermes.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[388] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:12%; width: 5%" target="_blank"
              @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="minilinks articles2" style="bottom:4%; left:18%; width: 4.5%" target="_blank"
              @click="openLink('https://www.falke.com/')">falke.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[389] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 10.5%" target="_blank"
              @click="openLink('https://www.louisvuitton.com/')">louisvuitton.com</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 4.5%" target="_blank"
              @click="openLink('https://www.falke.com/')">falke.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[390] + ')'"></div>
            <div :style="'background-image:url(' + pages12[391] + ')'">
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 6%" target="_blank"
              @click="openLink('https://www.dior.com/')">dior.com</a>
            </div>
            <!-------------->
            <!-- Stockist -->
            <!-------------->
            <div :style="'background-image:url(' + pages12[392] + ')'">
             <!-- left -->
             <a class="links articles2" style="bottom:80.1%; left:27%" target="_blank"
                @click="openLink('https://www.apc-us.com/')">apc-us.com </a>
              <a class="links articles2" style="bottom:75.2%; left:27%" target="_blank"
                @click="openLink('https://abelfragrance.com/')">abelfragrance.com</a>
              <a class="links articles2" style="bottom:70.2%; left:27%" target="_blank"
                @click="openLink('https://www.acnestudios.com')">acnestudios.com</a>
              <a class="links articles2" style="bottom:65.3%; left:27%" target="_blank"
                @click="openLink('https://www.adidas.com/')">adidas.com</a>
              <a class="links articles2" style="bottom:60.4%; left:27%" target="_blank"
                @click="openLink('https://adriancashmere.com/')">adriancashmere.com</a>
              <a class="links articles2" style="bottom:55.4%; left:27%" target="_blank"
                @click="openLink('https://www.ariesarise.com/')">ariesarise.com</a>
              <a class="links articles2" style="bottom:50.5%; left:27%" target="_blank"
                @click="openLink('https://www.baggu.com/')">baggu.com</a>
              <a class="links articles2" style="bottom:45.6%; left:27%" target="_blank"
                @click="openLink('https://www.balenciaga.com/')">balenciaga.com</a>
              <a class="links articles2" style="bottom:40.6%; left:27%" target="_blank"
                @click="openLink('https://bless-service.de/')">bless-service.de</a>
              <a class="links articles2" style="bottom:35.7%; left:27%" target="_blank"
                @click="openLink('https://us.burberry.com/')">burberry.com</a>
              <a class="links articles2" style="bottom:30.7%; left:27%" target="_blank"
                @click="openLink('https://www.burton.co.uk/')">burton.co.uk</a>
              <a class="links articles2" style="bottom:25.8%; left:27%" target="_blank"
                @click="openLink('https://www.calvinklein.com')">calvinklein.com</a>
              <a class="links articles2" style="bottom:20.9%; left:27%" target="_blank"
                @click="openLink('https://carlospenna.design/')">carlospenna.design</a>
              <a class="links articles2" style="bottom:15.9%; left:27%" target="_blank"
                @click="openLink('https://www.celine.com/')">celine.com</a>
              <!-- right -->
              <a class="links articles2" style="bottom:80.1%; left:61.5%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk </a>
              <a class="links articles2" style="bottom:75.2%; left:61.5%" target="_blank"
                @click="openLink('https://www.champion.com/')">champion.com</a>
              <a class="links articles2" style="bottom:70.2%; left:61.5%" target="_blank"
                @click="openLink('https://www.chanel.com/')">chanel.com</a>
              <a class="links articles2" style="bottom:65.3%; left:61.5%" target="_blank"
                @click="openLink('https://www.charlottetilbury.com/')">charlottetilbury.com</a>
              <a class="links articles2" style="bottom:60.4%; left:61.5%" target="_blank"
                @click="openLink('https://www.chloe.com/')">chloe.com</a>
              <a class="links articles2" style="bottom:55.4%; left:61.5%" target="_blank"
                @click="openLink('https://chylak.com/eu/en/')">chylak.com</a>
              <a class="links articles2" style="bottom:50.5%; left:61.5%" target="_blank"
                @click="openLink('https://www.converse.com/')">converse.com</a>
              <a class="links articles2" style="bottom:45.6%; left:61.5%" target="_blank"
                @click="openLink('https://shop.diesel.com/')">diesel.com</a>
              <a class="links articles2" style="bottom:40.6%; left:61.5%" target="_blank"
                @click="openLink('https://www.dior.com/')">dior.com</a>
              <a class="links articles2" style="bottom:35.7%; left:61.5%" target="_blank"
                @click="openLink('https://parley.tv/initiatives/dior')">parley.tv/initiatives/dior</a>
              <a class="links articles2" style="bottom:30.7%; left:61.5%" target="_blank"
                @click="openLink('https://www.dolcegabbana.com/')">dolcegabbana.com</a>
              <a class="links articles2" style="bottom:25.8%; left:61.5%" target="_blank"
                @click="openLink('https://www.drmartens.com/')">drmartens.com</a>
              <a class="links articles2" style="bottom:20.9%; left:61.5%" target="_blank"
                @click="openLink('https://www.dsquared2.com/')">dsquared2.com</a>
              <a class="links articles2" style="bottom:15.9%; left:61.5%" target="_blank"
                @click="openLink('https://elvdenim.com/')">elvdenim.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[393] + ')'">
               <!-- left -->
               <a class="links articles2" style="bottom:80.1%; left:5%" target="_blank"
                @click="openLink('https://elliotrhodes.com/')">elliotrhodes.com</a>
              <a class="links articles2" style="bottom:75.2%; left:5%" target="_blank"
                @click="openLink('https://ereperez.com/')">ereperez.com</a>
              <a class="links articles2" style="bottom:70.2%; left:5%" target="_blank"
                @click="openLink('https://www.falke.com/')">falke.com</a>
              <a class="links articles2" style="bottom:65.3%; left:5%" target="_blank"
                @click="openLink('https://www.fila.com/')">fila.com</a>
              <a class="links articles2" style="bottom:60.4%; left:5%" target="_blank"
                @click="openLink('https://www.filippa-k.com/')">filippa-k.com</a>
              <a class="links articles2" style="bottom:55.4%; left:5%" target="_blank"
                @click="openLink('https://www.florentinaleitner.com/')">florentinaleitner.com</a>
              <a class="links articles2" style="bottom:50.5%; left:5%" target="_blank"
                @click="openLink('https://www.franceso.co.uk/')">franceso.co.uk</a>
              <a class="links articles2" style="bottom:45.6%; left:5%" target="_blank"
                @click="openLink('https://www.fruit.com/')">fruit.com</a>
              <a class="links articles2" style="bottom:40.6%; left:5%" target="_blank"
                @click="openLink('https://www.ghbass.com/')">ghbass.com</a>
              <a class="links articles2" style="bottom:35.7%; left:5%" target="_blank"
                @click="openLink('https://gabrielahearst.com/')">gabrielahearst.com</a>
              <a class="links articles2" style="bottom:30.7%; left:5%" target="_blank"
                @click="openLink('https://www.gentlemonster.com/')">gentlemonster.com</a>
              <a class="links articles2" style="bottom:25.8%; left:5%" target="_blank"
                @click="openLink('https://www.givenchy.com/')">givenchy.com</a>
              <a class="links articles2" style="bottom:20.9%; left:5%" target="_blank"
                @click="openLink('https://gomi.design/')">gomi.design</a>
              <a class="links articles2" style="bottom:15.9%; left:5%" target="_blank"
                @click="openLink('https://www.gucci.com/')">gucci.com</a>
              <!-- right -->
              <a class="links articles2" style="bottom:80.1%; left:41.5%" target="_blank"
                @click="openLink('https://www.h2erg.co.uk/')">h2erg.co.uk </a>
              <a class="links articles2" style="bottom:75.2%; left:41.5%" target="_blank"
                @click="openLink('https://www.hanes.com/')">hanes.com</a>
              <a class="links articles2" style="bottom:70.2%; left:41.5%" target="_blank"
                @click="openLink('https://www.cenci.co.uk/')">Cenci.co.uk</a>
              <a class="links articles2" style="bottom:65.3%; left:41.5%" target="_blank"
                @click="openLink('https://www.havaianas.com/')">havaianas.com</a>
              <a class="links articles2" style="bottom:60.4%; left:41.5%" target="_blank"
                @click="openLink('https://www.hermes.com/')">hermes.com</a>
              <a class="links articles2" style="bottom:55.4%; left:41.5%" target="_blank"
                @click="openLink('https://isabelmarant.com/')">isabelmarant.com</a>
              <a class="links articles2" style="bottom:50.5%; left:41.5%" target="_blank"
                @click="openLink('https://www.isseymiyake.com')">isseymiyake.com</a>
              <a class="links articles2" style="bottom:45.6%; left:41.5%" target="_blank"
                @click="openLink('https://www.janissavitt.com/')">Janissavitt.com</a>
              <a class="links articles2" style="bottom:40.6%; left:41.5%" target="_blank"
                @click="openLink('https://shop.doverstreetmarket.com/')">shop.doverstreetmarket.com</a>
              <a class="links articles2" style="bottom:35.7%; left:41.5%" target="_blank"
                @click="openLink('https://karolinevitto.com/')">karolinevitto.com</a>
              <a class="links articles2" style="bottom:30.7%; left:41.5%" target="_blank"
                @click="openLink('https://www.kenzo.com/')">kenzo.com</a>
              <a class="links articles2" style="bottom:25.8%; left:41.5%" target="_blank"
                @click="openLink('https://kolor.jp/')">kolor.jp</a>
              <a class="links articles2" style="bottom:20.9%; left:41.5%" target="_blank"
                @click="openLink('https://lekilt.co.uk/')">lekilt.co.uk</a>
              <a class="links articles2" style="bottom:15.9%; left:41.5%" target="_blank"
                @click="openLink('https://www.loewe.com/')">loewe.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[394] + ')'"></div>
            <div :style="'background-image:url(' + pages12[395] + ')'"></div>
            <div :style="'background-image:url(' + pages12[396] + ')'">
              <!-- left -->
            <a class="links articles2" style="bottom:77.6%; left:26.5%" target="_blank"
                @click="openLink('https://www.longchamp.com/')">longchamp.com </a>
            <a class="links articles2" style="bottom:72.7%; left:26.5%" target="_blank"
                @click="openLink('https://www.louisvuitton.com/')">louisvuitton.com </a>
              <a class="links articles2" style="bottom:67.7%; left:26.5%" target="_blank"
                @click="openLink('https://www.lucybarlow.com/')">lucybarlow.com</a>
              <a class="links articles2" style="bottom:62.9%; left:26.5%" target="_blank"
                @click="openLink('https://www.maisonmargiela.com/')">maisonmargiela.com</a>
              <a class="links articles2" style="bottom:58%; left:26.5%" target="_blank"
                @click="openLink('https://www.maccosmetics.com/')">maccosmetics.com</a>
              <a class="links articles2" style="bottom:52.9%; left:26.5%" target="_blank"
                @click="openLink('https://miharayasuhiro.jp/')">miharayasuhiro.jp</a>
              <a class="links articles2" style="bottom:48%; left:26.5%" target="_blank"
                @click="openLink('https://www.marcjacobs.com/')">marcjacobs.com</a>
              <a class="links articles2" style="bottom:43%; left:26.5%" target="_blank"
                @click="openLink('https://martine-rose.com/')">martine-rose.com</a>
              <a class="links articles2" style="bottom:38.1%; left:26.5%" target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/')">alexandermcqueen.com</a>
              <a class="links articles2" style="bottom:33.2%; left:26.5%" target="_blank"
                @click="openLink('https://milomaria.com/')">milomaria.com</a>
              <a class="links articles2" style="bottom:28.2%; left:26.5%" target="_blank"
                @click="openLink('https://www.miumiu.com/')">miumiu.com</a>
              <a class="links articles2" style="bottom:23.4%; left:26.5%" target="_blank"
                @click="openLink('https://www.monclondon.com/')">monclondon.com</a>
              <!-- right -->
              <a class="links articles2" style="bottom:77.6%; left:61.4%" target="_blank"
                @click="openLink('https://www.moschino.com/')">moschino.com </a>
            <a class="links articles2" style="bottom:72.7%; left:61.4%" target="_blank"
                @click="openLink('https://www.shop-msgm.com/')">msgm.com </a>
              <a class="links articles2" style="bottom:67.7%; left:61.4%" target="_blank"
                @click="openLink('https://www.nike.com/')">nike.com</a>
              <a class="links articles2" style="bottom:62.9%; left:61.4%" target="_blank"
                @click="openLink('https://www.numeroventuno.com/')">numeroventuno.com
              </a>
              <a class="links articles2" style="bottom:58%; left:61.4%" target="_blank"
                @click="openLink('https://www.on.com/')">on.com</a>
              <a class="links articles2" style="bottom:52.9%; left:61.4%" target="_blank"
                @click="openLink('https://ouest.world/')">Ouest.world</a>
              <a class="links articles2" style="bottom:48%; left:61.4%" target="_blank"
                @click="openLink('https://www.pashley.co.uk/')">pashley.co.uk</a>
              <a class="links articles2" style="bottom:43%; left:61.4%" target="_blank"
                @click="openLink('https://www.patou.com/')">Patou.com</a>
              <a class="links articles2" style="bottom:38.1%; left:61.4%" target="_blank"
                @click="openLink('https://plantfacedclothing.com/')">plantfacedclothing.com</a>
              <a class="links articles2" style="bottom:33.2%; left:61.4%" target="_blank"
                @click="openLink('https://www.prada.com/')">prada.com</a>
              <a class="links articles2" style="bottom:28.2%; left:61.4%" target="_blank"
                @click="openLink('https://www.r13.com/')">r13.com</a>
              <a class="links articles2" style="bottom:23.4%; left:61.4%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">ralphlauren.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[397] + ')'">
               <!-- left -->
             <a class="links articles2" style="bottom:77.6%; left:5%" target="_blank"
                @click="openLink('https://www.rokeratelier.com/')">rokeratelier.com
              </a>
              <a class="links articles2" style="bottom:70.3%; left:5%" target="_blank"
                @click="openLink('https://www.ysl.com/')">ysl.com</a>
              <a class="links articles2" style="bottom:65.3%; left:5%" target="_blank"
                @click="openLink('https://www.sayebrand.com/')">sayebrand.com</a>
              <a class="links articles2" style="bottom:60.4%; left:5%" target="_blank"
                @click="openLink('https://simonerocha.com/')">simonerocha.com</a>
              <a class="links articles2" style="bottom:55.4%; left:5%" target="_blank"
                @click="openLink('https://www.storymfg.com/')">storymfg.com</a>
              <a class="links articles2" style="bottom:50.5%; left:5%" target="_blank"
                @click="openLink('https://www.stussy.com/')">stussy.com</a>
              <a class="links articles2" style="bottom:45.6%; left:5%" target="_blank"
                @click="openLink('https://www.thenorthface.com/')">thenorthface.com</a>
              <a class="links articles2" style="bottom:40.6%; left:5%" target="_blank"
                @click="openLink('https://www.thombrowne.com/')">thombrowne.com/</a>
              <a class="links articles2" style="bottom:35.7%; left:5%" target="_blank"
                @click="openLink('https://www.tomfordbeauty.com/')">tomfordbeauty.com</a>
              <a class="links articles2" style="bottom:30.8%; left:5%" target="_blank"
                @click="openLink('https://turnbullandasser.com/')">turnbullandasser.com</a>
              <a class="links articles2" style="bottom:25.9%; left:5%" target="_blank"
                @click="openLink('https://www.youmustcreate.com/')">youmustcreate.com</a>
              <a class="links articles2" style="bottom:21%; left:5%" target="_blank"
                @click="openLink('https://zeromariacornejo.com/')">zeromariacornejo.com</a>
            </div>
            <div :style="'background-image:url(' + pages12[398] + ')'"></div>
            <div :style="'background-image:url(' + pages12[399] + ')'"></div>
            <div :style="'background-image:url(' + pages12[400] + ')'"></div>
            <div :style="'background-image:url(' + pages12[401] + ')'">
              <a class="minilinks articles2" style="bottom:15.6%; left:38%; width: 24%" target="_blank"
                @click="openLink('mailto:info@missionmag.org')">Code Of Ethics
              </a>
            </div>
            <div :style="'background-image:url(' + pages12[402] + ')'"></div>
            <!------------------->
            <!-- end issue12  -->
            <!------------------->

          </div>
          <!--------------------->
          <!-- Videos embed -->
          <!--------------------->
          <div class="flipbook-video video-content" id="video-Banner01" v-show="verBanner01">
            <b-embed type="video" :src="infoModalbanner01.src" id="videoBanner01" autoplay allow="autoplay"
              :controls="false" allowfullscreen>
            </b-embed>
          </div>
          <div class="flipbook-video video-content" id="video-Banner02" v-show="verBanner02">
            <b-embed type="video" :src="infoModalbanner02.src" id="videoBanner02" autoplay allow="autoplay"
              :controls="false" allowfullscreen>
            </b-embed>
          </div>
          <div class="flipbook-video video-banner3" id="video-Banner03" v-show="verBanner03">
            <b-embed type="video" :src="infoModalbanner03.src" id="videoBanner03" autoplay allow="autoplay"
              :controls="false" allowfullscreen>
            </b-embed>
          </div>
          <div class="flipbook-video video-content1" id="video-Banner04" v-show="verBanner04">
            <b-embed type="video" :src="infoModalbanner04.src" id="videoBanner04" autoplay allow="autoplay"
              :controls="false" allowfullscreen>
            </b-embed>
          </div>
          <div class="flipbook-video video-content1" id="video-Banner05" v-show="verBanner05">
            <b-embed type="video" :src="infoModalbanner05.src" id="videoBanner05" autoplay allow="autoplay"
              :controls="false" allowfullscreen>
            </b-embed>
          </div>
        </div>
        
      </div>
      <index v-if="index"></index>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import '@/lib/turn.js';
import '@/lib/zoom.js';
import '@/lib/hash.js'
import index from './Index'
import loader from "../../containers/loader";
import vuePlayer from '@algoz098/vue-player'
import {
  mapState,
  mapActions,
  mapMutations
} from "vuex";

export default {
  components: {
    index,
    loader,
    vuePlayer
    // navIndex
  },
  data() {
    return {
      estado: '/issue-11',
      infoModalbanner01: {
        src: '',
        isPlay: false,
      },
      verBanner01: false,      
      infoModalbanner02: {
        src: '',
        isPlay: false,
      },
      verBanner02: false,      
      infoModalbanner03: {
        src: '',
        isPlay: false,
      },
      verBanner03: false,      
      infoModalbanner04: {
        src: '',
        isPlay: false,
      },
      verBanner04: false,      
      infoModalbanner05: {
        src: '',
        isPlay: false,
      },
      verBanner05: false,      
    }
  },
  async beforeMount() {
    await this.loadMagazine12()

  },
  mounted() {

    function loadApp() {
      $("#canvas").fadeIn(4000);
      var o = $(".flipbook");
      0 != o.width() && 0 != o.height() ? (o.turn({
        width: 1650,
        height: 990,
        duration: 4000,
        acceleration: !isChrome(),
        gradients: !0,
        autoCenter: !0,
        elevation: 200,
        when: {
          turning: function (o, i, n) {
            var e = $(this),
              a = e.turn("page");
            e.turn("pages");
            var btnClick = document.getElementById('btnClick');
            
            btnClick.onmousedown = function () {
              btnClick.onmousedown = function() {
              const media1 = document.getElementById("videoBanner01");
              media1.pause();
              const media2 = document.getElementById("videoBanner02");
              media2.pause();
              const media3 = document.getElementById("videoBanner03");
              media3.pause();
              const media4 = document.getElementById("videoBanner04");
              media4.pause();
              const media5 = document.getElementById("videoBanner05");
              media5.pause();
              $("#video-Banner01,#video-Banner02,#video-Banner03,#video-Banner04,#video-Banner05").hide();
              //pauseVideo()
            };       
            };
            disableControls(i),
              $(".thumbnails .page-" + a).parent().removeClass("current"),
              $(".thumbnails .page-" + i).parent().addClass("current")
          },
          turned: function (o, i, n) {
            disableControls(i), $(this).turn("center"), 1 == i && $(this).turn("peel", "br")
          },
          missing: function (o, i) {
            for (var n = 0; n < i.length; n++) addPage(i[n], $(this))
          }
        }
      }), $(".flipbook-viewport").zoom({
        flipbook: $(".flipbook"),
        max: function () {
          return largeMagazineWidth() / $(".flipbook").width()
        },
        when: {
          swipeLeft: function () {
            $(this).zoom("flipbook").turn("next")
          },
          swipeRight: function () {
            $(this).zoom("flipbook").turn("previous")
          },
          resize: function (o, i, n, e) {
            1 == i ? loadSmallPage(n, e) : loadLargePage(n, e)
          },
          zoomIn: function () {
            $(".thumbnails").hide(), $(".made").hide(),
              $(".flipbook").removeClass("animated").addClass("zoom-in"),
              $(".zoom-icon").removeClass("zoom-icon-in").addClass("zoom-icon-out"),
              window.escTip || $.isTouch || (escTip = !0)
          },
          zoomOut: function () {
            $(".exit-message").hide(),
              $(".made").fadeIn(),
              $(".zoom-icon").removeClass("zoom-icon-out").addClass("zoom-icon-in"),
              setTimeout(function () {
                $(".flipbook").addClass("animated").removeClass("zoom-in"), resizeViewport()
              }, 0)
          }
        }
      }),
        // pasar hojas con flechas

        $(document).keydown(function (e) {
          var options = $('.flipbook').turn('options');

          var previous = 37,
            next = 39,
            esc = 27;

          switch (e.keyCode) {
            case previous:

              // left arrow
              $('.flipbook').turn('previous');
              e.preventDefault();
              break;

            case next:
              //right arrow
              $('.flipbook').turn('next');
              e.preventDefault();
              break;

            case esc:
              $(".flipbook").turn("size", options.width, options.height);
              e.preventDefault();

              break;
          }
        }),
        $(window).resize(function () {
          resizeViewport()
        }).bind("orientationchange", function () {
          resizeViewport()
        }),
        // $.isTouch ? $(".flipbook").bind("touchstart", regionClick) : $(".flipbook").click(regionClick), 
        resizeViewport(),
        $(".flipbook").addClass("animated")) : setTimeout(loadApp, 10)
    }
    $(".zoom-icon").bind("mouseover", function () {
      $(this).hasClass("zoom-icon-in") && $(this).addClass("zoom-icon-in-hover"),
        $(this).hasClass("zoom-icon-out") && $(this).addClass("zoom-icon-out-hover")
    }).on("mouseout", function () {
      $(this).hasClass("zoom-icon-in") && $(this).removeClass("zoom-icon-in-hover"),
        $(this).hasClass("zoom-icon-out") && $(this).removeClass("zoom-icon-out-hover")
    }).on("click", function () {
      toggleFullscreen()
    }), $("#canvas").hide()

    //FUNCTIONS TURNJS
    function resizeViewport() {

      var width = $(window).width(),
        height = $(window).height(),
        options = $('.flipbook').turn('options');

      $('.flipbook').removeClass('animated');

      $('.flipbook-viewport').css({
        width: width,
        height: height
      }).zoom('resize');

      if ($('.flipbook').turn('zoom') == 1) {
        var bound = calculateBound({
          width: options.width,
          height: options.height,
          boundWidth: Math.min(options.width, width),
          boundHeight: Math.min(options.height, height)
        });

        if (bound.width % 2 !== 0)
          bound.width -= 1;

        if (bound.width != $('.flipbook').width() || bound.height != $('.flipbook').height()) {

          $('.flipbook').turn('size', bound.width, bound.height);

          if ($('.flipbook').turn('page') == 1)
            $('.flipbook').turn('peel', 'br');

          $('.next-button').css({
            height: bound.height,
            backgroundPosition: '-38px ' + (bound.height / 2 - 32 / 2) + 'px'
          });
          $('.previous-button').css({
            height: bound.height,
            backgroundPosition: '-4px ' + (bound.height / 2 - 32 / 2) + 'px'
          });
        }

        $('.flipbook').css({
          top: -bound.height / 2,
          left: -bound.width / 2
        });
        $(".flipbook-video").css({
          width: bound.width,
          height: bound.height,
          top: -bound.height / 2,
          left: -bound.width / 2,
          padding: 15,
        });

      }

      var magazineOffset = $('.flipbook').offset(),
        boundH = height - magazineOffset.top - $('.flipbook').height(),
        marginTop = (boundH - $('.thumbnails > div').height()) / 2;

      if (marginTop < 0) {
        $('.thumbnails').css({
          height: 1
        });
      } else {
        $('.thumbnails').css({
          height: boundH
        });
        $('.thumbnails > div').css({
          marginTop: marginTop
        });
      }

      if (magazineOffset.top < $('.made').height())
        $('.made').hide();
      else
        $('.made').show();

      $('.flipbook').addClass('animated');

    }

    function isChrome() {
      return navigator.userAgent.indexOf('Chrome') != -1;
    }

    function calculateBound(d) {

      var bound = {
        width: d.width,
        height: d.height
      };

      if (bound.width > d.boundWidth || bound.height > d.boundHeight) {

        var rel = bound.width / bound.height;

        if (d.boundWidth / rel > d.boundHeight && d.boundHeight * rel <= d.boundWidth) {

          bound.width = Math.round(d.boundHeight * rel);
          bound.height = d.boundHeight;

        } else {

          bound.width = d.boundWidth;
          bound.height = Math.round(d.boundWidth / rel);

        }
      }

      return bound;
    }

    function toggleFullscreen(elem) {
      var options = $('.flipbook').turn('options');

      elem = elem || document.documentElement;
      if (!document.fullscreenElement && !document.mozFullScreenElement &&
        !document.webkitFullscreenElement && !document.msFullscreenElement) {

        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        }
      }
    }

    function disableControls(page) {
      if (page == 1)
        $('.previous-button').hide();
      else
        $('.previous-button').show();

      if (page == $('.flipbook').turn('pages'))
        $('.next-button').hide();
      else
        $('.next-button').show();
    }

    function loadSmallPage(page, pageElement) {

      var img = pageElement.find('img');

      img.css({
        width: '100%',
        height: '100%'
      });

      img.unbind('load');
      // Loadnew page

      //  img.attr('src', 'pages/' + page + '.jpg');
    }

    // large page
    function loadLargePage(page, pageElement) {


      var img = $('<img />');

      img.load(function () {

        var prevImg = pageElement.find('img');

        $(this).css({
          width: '100%',
          height: '100%'
        });
        $(this).appendTo(pageElement);
        prevImg.remove();

      });
    }

    loadApp()

  },
  methods: {
    onPlayerReadybanner01(reproducir, mini) {
      this.infoModalbanner01.isPlay = true;
      this.infoModalbanner01.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoBanner01");
        media.load();
        media.play();
        this.infoModalbanner01.isPlay = true;
        this.verBanner01 = true;
      }, 100);
    },
    onPlayerReadybanner02(reproducir, mini) {
      this.infoModalbanner02.isPlay = true;
      this.infoModalbanner02.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoBanner02");
        media.load();
        media.play();
        this.infoModalbanner02.isPlay = true;
        this.verBanner02 = true;
      }, 100);
    },
    onPlayerReadybanner03(reproducir, mini) {
      this.infoModalbanner03.isPlay = true;
      this.infoModalbanner03.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoBanner03");
        media.load();
        media.play();
        this.infoModalbanner03.isPlay = true;
        this.verBanner03 = true;
      }, 100);
    },
    onPlayerReadybanner04(reproducir, mini) {
      this.infoModalbanner04.isPlay = true;
      this.infoModalbanner04.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoBanner04");
        media.load();
        media.play();
        this.infoModalbanner04.isPlay = true;
        this.verBanner04 = true;
      }, 100);
    },
    onPlayerReadybanner05(reproducir, mini) {
      this.infoModalbanner05.isPlay = true;
      this.infoModalbanner05.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoBanner05");
        media.load();
        media.play();
        this.infoModalbanner05.isPlay = true;
        this.verBanner05 = true;
      }, 100);
    },
    playAudio(audio) {
      this.listenAudioI12(true);
      audio.file.play();
    },
    pauseAudio(audio) { 
      audio.file.pause();
      this.listenAudioI12(false); 
    },

    cambiarEstado(newEstado) {
      this.estado = newEstado;
      if (newEstado == '/index') {
        this.setClass(true)
        this.pause();
      } else {
        this.$router.push(this.estado)
        this.setClass(false)
        this.pause();
      }
    },
    openLink(url) {
      window.open(url)
    },

    pause() {
      if (this.audioI12.isPlaying == true) {
        console.log("🚀 ~ pause ~ this.audioI12.isPlaying:", this.audioI12.isPlaying)
        this.audioI12.file.pause();
        console.log("🚀 ~ ause ~  this.audioI12.file.:",  this.audioI12.file.pause)
        this.listenAudioI12(false);
      }
      if (this.infoModalbanner01.isPlay == true) {
        const media = document.getElementById("videoBanner01");
        media.pause();
        this.verBanner01 = false;
        this.infoModalbanner01.isPlay = false;
      }
      if (this.infoModalbanner02.isPlay == true) {
        const media = document.getElementById("videoBanner02");
        media.pause();
        this.verBanner02 = false;
        this.infoModalbanner02.isPlay = false;
      }
      if (this.infoModalbanner03.isPlay == true) {
        const media = document.getElementById("videoBanner03");
        media.pause();
        this.verBanner03 = false;
        this.infoModalbanner03.isPlay = false;
      }
      if (this.infoModalbanner04.isPlay == true) {
        const media = document.getElementById("videoBanner04");
        media.pause();
        this.verBanner04 = false;
        this.infoModalbanner04.isPlay = false;
      }
      if (this.infoModalbanner05.isPlay == true) {
        const media = document.getElementById("videoBanner05");
        media.pause();
        this.verBanner05 = false;
        this.infoModalbanner05.isPlay = false;
      }
      if (this.$refs.video1.playing == true) {
        this.$refs.video1.playing == false
        this.$refs.video1.$refs.video.pause()
      }     
    },

    playVideo01() {
      this.$refs.video1.$refs.video.load();
      this.$refs.video1.$refs.video.play()
    },
   
    pageNext() {
      $('.flipbook').turn('next');
      this.pause()
    },
    pagePrev() {
      $('.flipbook').turn('previous');;
      this.pause()
    },
    openBook() {
      let route = this.$router.resolve("/colorbook/12");
      window.open(route.href, "_blank");
    },

    ...mapActions('magazine', [
      'loadMagazine12'
    ]),
    ...mapMutations('magazine', [
      'setClass',
      "listenAudioI12"
    ]),
  },
  computed: {
    watchCover(){
      return this.seeCover
    },
    ...mapState('magazine', [
      'index',
      'pages12',
      'loading',
      'seeCover',
      'media',
      "audioI12"
    ])
  },

}
</script>

<style lang="scss">
video {
  object-fit: cover !important;
}

.video01 {
  position: absolute;
  top: 20%;
  margin-left: 4.5%;
  width: 90%;
  z-index: 12;
}

#video01 {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }

  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }

  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}
.musicPlayer12 {
        margin-top: 112%;
        width: 81%;
        height: 20px;
        margin-left: 12%;
        color: transparent
    }

.video-content {
	.embed-responsive {
    position: absolute;
    z-index: 1000;
    width: 97.6%;
    height: 61%;
    top: 4.7%;
    left: 1%;
	}
}

.video-content1 {
	.embed-responsive {
    position: absolute;
    z-index: 1000;
    width: 95.1%;
    height: 61.9%;
    top: 5.4%;
    left: 2.3%;
	}
}
.video-banner3 {
	.embed-responsive {
    position: absolute;
    z-index: 1000;
    width: 98%;
    height: 80%;
    top: 4.7%;
    left: 1%;
	}
}

.start-button {
  width: auto;
  height: auto;
  border: none !important;
  background-color: rgba(0, 0, 0, 0) !important;
  color: rgba(255, 255, 255, 0.6) !important;
  cursor: pointer;
  margin-top: 100px;
}

.vue-video-player-controls {
  max-height: 5px;
  display: flex;
  left: 7% !important;
  right: 7% !important;
  padding: 5px;
  position: absolute;
  bottom: 14% !important;
  background-color: rgba(0, 0, 0, 0) !important;
}


.vue-player-time-control {
  position: absolute;
  top: -5px;
  left: 0;
  padding-top: 0;
  color: rgba(255, 255, 255, 0.3) !important;
  display: block;
}


.button {
  width: 35px;
  border: none !important;
  color: rgba(255, 255, 255, 0.6) !important;
  background-color: transparent;
}

.minilinksblack {
  position: absolute;
  cursor: pointer;
  color: black;
  font-family: 'lemon_milkregular';
  font-style: italic;
  -webkit-font-smoothing: antialiased;
  font-size: 0.8em;
  z-index: 100;
  text-decoration: underline;
}
</style>
